export default {
    address: {
        city: "Ville",
        city_locality: "Ville \/ Localité",
        country: "Pays",
        line1: "Adresse Ligne 1",
        line2: "Adresse ligne 2",
        postal_code: "Code Postal",
        state: "État",
        state_region: "État \/ Région"
    },
    alerts: {
        account_2fa: "Sécurisez votre compte avec l'authentification à deux facteurs.",
        account_2fa_success: "L'authentification à deux facteurs est activée.",
        activate_instruction: "L'activation de la collecte automatique d'avis tentera de demander un avis à {count}. Consultez vos modèles avant de l'activer.",
        activate_intro: "Demandez continuellement des avis en fonction de votre stratégie.",
        agency_mcp_server: "Connectez Claude ou tout autre client MCP au serveur MCP de votre agence. Les assistants autorisés pourront gérer les projets, les clients et l'équipe de votre agence en votre nom.",
        agency_sso: "Connectez un fournisseur d'identité OpenID Connect pour la connexion client.",
        ai_assistant: "Le nom et la description de votre entreprise sont requis pour utiliser l'IA pour les suggestions d'avis et les réponses.",
        ai_description_required: "Ajoutez une description de l’entreprise dans Paramètres → Projet pour utiliser les outils d’IA.",
        ai_review_pages: "Autorisez les suggestions d’avis par IA sur les pages que vous sélectionnez.",
        api_key_roll: "Êtes-vous sûr de vouloir modifier votre clé API? Cela affectera toutes les applications qui l’utilisent.",
        ask_confirm: "Êtes-vous sûr de vouloir demander des avis à {count}? Cela planifiera les demandes pour tous les clients qui n'ont pas encore été sollicités.",
        automate_highlights: "Mettez automatiquement en évidence des phrases dans les nouveaux avis positifs.",
        automate_replies: "Publiez automatiquement des réponses IA aux nouveaux avis Google et Facebook. Nécessite une [intégration Google ou Facebook](/settings/integrations?tab=review).",
        cname_delete: "Êtes-vous sûr de vouloir supprimer le CNAME: {cname_name} ?",
        cname_not_configured: "Cet enregistrement n'a pas encore été configuré. Veuillez patienter...",
        cname_warning: "Les messages qui ont déjà été envoyés à vos clients auront des liens brisés.",
        connection_disabled: "La connexion est désactivée. Veuillez vous reconnecter.",
        customer_archive: "Êtes-vous sûr de vouloir archiver le client: {customer_name}? Tous les messages non envoyés seront annulés.",
        customer_cancel: "Êtes-vous sûr de vouloir annuler tous les messages non envoyés pour le client: {customer_name}?",
        customer_ingest: "Incluez cette adresse e-mail dans le champ BCC lors de l'envoi d'e-mails à vos clients pour que leur nom et leur adresse e-mail soient importés automatiquement.",
        customer_resubscribe: "Êtes-vous sûr de vouloir réabonner le client : {customer_name} ?",
        customer_unarchive: "Êtes-vous sûr de vouloir désarchiver le client: {customer_name}?",
        customer_unsubscribe: "Êtes-vous sûr de vouloir désabonner le client : {customer_name} ?",
        customer_unsubscribe_all: "Êtes-vous sûr de vouloir désabonner {count} de la réception des messages de ce projet ?",
        delete: "Êtes-vous sûr de vouloir supprimer le {model}: {name} ?",
        delete_count: "Êtes-vous sûr de vouloir supprimer {count}",
        domain_agency: "Ajoutez votre propre domaine d'envoi pour donner à votre agence une marque blanche complète.",
        domain_delete: "Êtes-vous sûr de vouloir supprimer le domaine: {name}? Nous continuerons à envoyer des e-mails depuis notre propre nom de domaine.",
        domain_dmarc: "Ajoutez un enregistrement DMARC à votre domaine pour réduire le risque que vos e-mails soient considérés comme du spam.",
        domain_project: "Ajoutez un domaine d'envoi afin que nous puissions envoyer des e-mails à vos clients à partir de votre propre nom de domaine.",
        export_confirm: "Êtes-vous sûr de vouloir exporter tous vos {model}?",
        export_count: "Êtes-vous sûr de vouloir exporter {count}?",
        export_link: "Un lien de téléchargement sera envoyé à {email} peu de temps après votre demande.",
        highlights_save_disabled: "Vous pouvez, si vous le souhaitez, supprimer les surlignages de toutes les avis qui en comportent actuellement.",
        highlights_save_enabled: "Pour mettre en évidence tous les avis positifs, cochez la case ci-dessous. Si vous souhaitez uniquement modifier la couleur de la mise en évidence, laissez la case décochée.",
        integration_disconnect: "Êtes-vous sûr de vouloir vous déconnecter de {integration_name}?",
        integration_sync: "Voulez-vous vraiment synchroniser votre compte {integration_name}? Nous importerons vos données en continu.",
        intro: "Prêt à obtenir plus d'avis positifs de vos clients ? Importez vos clients pour commencer. Demandez ensuite des avis manuellement ou cliquez sur le bouton Automatiser et laissez les avis affluer.",
        logout: "Êtes-vous sûr de vouloir vous déconnecter ?",
        mcp_server: "Connectez Claude ou tout autre client MCP à ce projet. Le serveur MCP permet aux assistants IA de lire et de gérer les avis, les clients et les messages en votre nom.",
        member_confirm: "Êtes-vous sûr de vouloir vous retirer du projet ? Vous perdrez l'accès à ce projet.",
        member_confirm_all: "Êtes-vous sûr de vouloir vous retirer ? Vous perdrez l'accès à tous vos projets.",
        member_other_confirm: "Êtes-vous sûr de vouloir supprimer le {noun}: {name}? Ils perdront l'accès à ce projet.",
        member_other_confirm_all: "Êtes-vous sûr de vouloir supprimer les {noun} {name}? Ils perdront l'accès à tous leurs projets.",
        message_cancel: "Êtes-vous sûr de vouloir annuler ce message ?",
        message_cancel_all: "Êtes-vous sûr de vouloir annuler {count}? Cette action ne peut être effectuée que sur les messages non envoyés.",
        message_delete: "Êtes-vous sûr de vouloir supprimer ce message ?",
        oauth_client_revoke: "Êtes-vous sûr de vouloir révoquer l'accès pour {client}? Toutes les sessions actives seront immédiatement déconnectées.",
        project_summary: "Impossible de générer un résumé pour le moment.",
        project_suspend: "Êtes-vous sûr de vouloir suspendre le projet : {project_name} ?",
        project_unsuspend: "Êtes-vous sûr de vouloir annuler la suspension du projet: {project_name}?",
        review_delete: "Êtes-vous sûr de vouloir supprimer cet avis? Cette action est irréversible.",
        review_page_confirm: "Êtes-vous sûr de vouloir enregistrer vos modifications ?",
        review_page_confirmation: "Affichez un message de confirmation sur la page de succès en fonction de la note sélectionnée.",
        review_page_default: "Voulez-vous vraiment que la page d'avis {name} soit votre page par défaut? Cette page sera utilisée si aucune autre page n'est affectée à une demande d'avis.",
        review_page_delete: "Êtes-vous sûr de vouloir supprimer la page d'avis: {name}? Tous les clients actuellement redirigés vers cette page seront redirigés vers votre page par défaut.",
        review_page_delete_all: "Êtes-vous sûr de vouloir supprimer {count}? Votre page d'avis par défaut ne sera pas supprimée.",
        review_page_fields: "Utilisez des champs pour recueillir les informations des clients lorsqu'ils laissent un avis. Ajoutez des champs à votre formulaire et affichez-les de manière conditionnelle lorsque les clients sélectionnent une note.",
        review_page_instructions: "Afficher les instructions directement au-dessus du formulaire après la sélection d'une note.",
        review_page_location_picker: "Permettez aux clients de sélectionner n'importe quel emplacement de votre projet pour l'avis. Cet emplacement sera présélectionné si la page d'avis doit être affichée pour un emplacement spécifique.",
        review_page_locations: "Sélectionnez les emplacements qui doivent utiliser cette page d'avis. Un emplacement ne peut être affecté qu'à une seule page d'avis. Si aucun emplacement n'est affecté, il utilisera la page d'avis par défaut.",
        review_page_redirects: "Ignorez le formulaire après avoir sélectionné une note et redirigez-la ailleurs. Vous pouvez également répartir le trafic vers plusieurs sites web en ajoutant plusieurs redirections pour chaque note.",
        share_template_delete: "Êtes-vous sûr de vouloir supprimer le modèle de partage «{name}»? Cette action est irréversible.",
        smtp_remove: "Voulez-vous vraiment supprimer la configuration SMTP de votre projet? Votre domaine d'envoi reviendra à sa configuration standard.",
        smtp_setup: "Envoyez des e-mails depuis votre propre serveur de messagerie. Saisissez vos identifiants SMTP . Si votre serveur utilise des restrictions d'adresses IP, veuillez ajouter les adresses IP suivantes à votre liste blanche: {ips}.",
        space_delete: "Êtes-vous sûr de vouloir supprimer l' espace: {name}? Tous les projets qu'il contient seront supprimés.",
        tag_rule: "Ajoutez un terme positif et son équivalent négatif. Si tel est le cas, nous utiliserons l'IA pour étiqueter automatiquement l'avis avec l'un ou l'autre.",
        user_delete: "Êtes-vous sûr de vouloir supprimer le compte utilisateur pour: {email}?",
        user_verify: "Pour vérifier votre adresse e-mail et activer votre compte, cliquez sur le lien dans l'e-mail envoyé à : {email}.",
        widget_delete: "Êtes-vous sûr de vouloir supprimer le widget: {name}? Il ne sera plus affiché sur aucun site web.",
        widget_restore: "Êtes-vous sûr de vouloir restaurer les paramètres du widget: {name}? Seul le design reviendra aux valeurs par défaut.",
        widgets_1: "Ajoutez ce script au corps de votre site Web.",
        widgets_2: "Le Mur d'avis présente tous vos avis sous forme de grille. Ajoutez ce script à l'emplacement où vous souhaitez afficher le widget.",
        widgets_3: "L'Avis en vedette présente un seul avis en grand format. Ajoutez ce script à l'emplacement où vous souhaitez afficher le widget."
    },
    billing_statuses: {
        active: "Votre abonnement est actif.",
        canceled: "Votre abonnement est annulé. Veuillez passer à un abonnement supérieur pour continuer.",
        ending: "Votre abonnement prend fin le {date}.",
        trial: "Votre essai gratuit se termine le {date}.",
        trial_expired: "Votre période d'essai gratuite est terminée. Veuillez passer à la version supérieure pour continuer.",
        trial_expiring: "Votre période d'essai gratuite se termine bientôt. Veuillez passer à la version supérieure pour continuer."
    },
    brands: {
        boost_space: "Boost.space",
        discord: "Discord",
        email: "E-mail",
        facebook: "Facebook",
        google: "Google",
        google_analytics: "Google Analytics",
        hubspot: "HubSpot",
        linkedin: "LinkedIn",
        make_com: "Make.com",
        messenger: "Messager",
        pabbly: "Pabbly",
        recaptcha: "reCAPTCHA",
        reddit: "Reddit",
        slack: "Slack",
        stripe: "Stripe",
        threads: "Fils",
        twilio: "Twilio",
        whatsapp: "WhatsApp",
        x: "X",
        zapier: "Zapier"
    },
    captions: {
        add_sending_domain: "Ajoutez un domaine d'envoi pour modifier votre adresse e-mail:",
        agency_robots: "Autorisez les moteurs de recherche à indexer votre portail client.",
        ai_business_description: "Une description détaillée de votre entreprise pour vous aider à générer des suggestions d'avis et des réponses.",
        ai_business_name: "Le nom de votre entreprise.",
        ai_highlights: "Mettez en évidence les meilleures phrases de vos avis positifs.",
        ai_highlights_instructions: "Indiquez à l’IA quelles phrases privilégier dans les surlignages.",
        ai_replies: "Rédigez et, si vous le souhaitez, automatisez les réponses à vos avis.",
        ai_reply_contact: "Inclus dans les réponses aux avis négatifs.",
        ai_reply_instructions: "Indiquez à l’IA le ton des réponses et ce qu’elles doivent contenir.",
        ai_review_instructions: "Indiquez à l’IA ce qu’il faut mentionner ou éviter dans les suggestions d’avis.",
        ai_review_suggestions: "Aidez les clients à rédiger des avis avec des suggestions prêtes à l’emploi.",
        ai_tags: "Étiquetez automatiquement les avis qui correspondent à vos instructions.",
        ask_location: "L'emplacement à attribuer à l'avis.",
        ask_review_page: "La page pour capturer l'avis.",
        assign_tags: "Attribuer des étiquettes à l'avis.",
        csv_max_rows: "Jusqu'à {count} lignes",
        dashboard_configure_settings: "Configurez les paramètres de votre projet.",
        dashboard_import_customers: "Importez vos clients.",
        dashboard_preview_email_templates: "Prévisualisez vos modèles d’e-mails.",
        dashboard_preview_kiosk_page: "Prévisualisez votre page de kiosque.",
        dashboard_preview_review_page: "Prévisualisez votre page d’avis.",
        dashboard_preview_showcase_page: "Prévisualisez votre page de présentation.",
        logo_height: "La hauteur du logo sur les e-mails et les pages.",
        meta_description: "Remplacer la description de la page.",
        meta_title: "Remplacer le titre de la page.",
        mfa_password: "Entrez le mot de passe de votre compte.",
        mfa_qr_code: "Scannez le code QR avec votre application d'authentification.",
        mfa_security_code: "Saisissez le code de votre application d'authentification.",
        override_ambassador: "Affichez un badge sur les e-mails, les pages et les widgets de vos clients.",
        project_name: "Le nom de votre entreprise, de votre marque ou de votre site Web.",
        project_robots: "Autorisez les moteurs de recherche à indexer vos pages d'avis et à les présenter.",
        project_slug: "Utilisé dans les e-mails et les liens destinés aux clients si aucun CNAME n'est configuré.",
        review_page_copied_message: "Affiché après qu'un avis positif a été soumis.",
        review_page_email_address: "Recevez des avis à cet email.",
        review_page_link_reveal_position: "Où révéler les liens.",
        review_page_link_revealer_label: "L'étiquette pour révéler les liens.",
        review_page_link_revealer_rating: "Révéler les liens si le client sélectionne cette note ou une note supérieure, sinon afficher un bouton pour les révéler.",
        review_page_native_reviews: "Autoriser les avis sur cette plateforme.",
        review_page_rating_selection: "Enregistrer la note avant de soumettre un avis.",
        review_page_success_button_link: "Si vide, le lien par défaut renvoie vers le site Web de votre projet, sinon vers le domaine de la page.",
        review_page_warning: "Empêcher les clients de laisser des avis publics peut entraîner la suppression de votre fiche d'entreprise.",
        review_reply_status: "Nous ne pouvons pas répondre publiquement à cet avis. Vous pouvez contacter directement son auteur.",
        review_suggestions: "Aidez les clients à rédiger des avis.",
        separate_with_commas: "Séparez les multiples par des virgules.",
        setup_basics: "Définissez quand et comment vous demandez des avis à vos clients.",
        setup_business: "Dites-nous le nom sous lequel vos clients vous connaissent.",
        setup_google: "Orientez vos clients vers votre profil Google , répondez aux avis et importez ceux existants. Vous pouvez ignorer cette étape et la réaliser plus tard.",
        setup_location_limit: "Votre essai comprend 1 emplacement. Passez à la version supérieure à tout moment pour synchroniser davantage de sites.",
        showcase_locations: "Limitez la présentation à des emplacements spécifiques.",
        showcase_review_length: "Les Avis doivent comporter au moins ce nombre de caractères.",
        showcase_since: "Afficher les avis créés à cette date ou avant.",
        showcase_sources: "Limitez la présentation à des sources spécifiques.",
        showcase_tags: "Limitez la présentation aux avis comportant des étiquettes spécifiques.",
        signature_html: "Copiez et collez la signature dans votre application de messagerie.",
        signed_up: "La date de début du client.",
        twilio_webhook: "Définir comme URL de rappel pour votre service de messagerie.",
        widget_embed: "L'attribut ID du conteneur div où le widget sera affiché."
    },
    labels: {
        accept_all: "Accepter tout",
        access_code: "Code d'accès",
        access_codes: "Codes d'accès",
        account: "Compte",
        account_sid: "SID du compte",
        action: "Action",
        actions: "Actions",
        activate: "Activer",
        active: "Actif",
        add: "Ajouter",
        add_agency_project: "Ajouter un projet d'agence",
        add_confirmation_message: "Ajoutez un message de confirmation.",
        add_css_rules: "Ajoutez vos propres règles CSS.",
        add_custom_field: "Ajouter un champ personnalisé",
        add_customer: "Ajouter un client",
        add_customers_with: "Ajouter des clients avec {model}",
        add_external_link: "Ajouter un Lien externe",
        add_external_links: "Ajouter des Liens externes",
        add_introduction: "Ajoutez une introduction.",
        add_js_tags: "Ajoutez vos propres balises JavaScript .",
        add_legal_information: "Ajouter des informations légales.",
        add_location: "Ajouter un lieu",
        add_project: "Ajouter un projet",
        add_review: "Ajouter un Avis",
        add_source: "Ajouter une source",
        add_tag: "Ajouter une Étiquette",
        added: "Ajouté",
        address: "Adresse",
        advanced_review_pages: "Pages d’Avis avancées",
        affiliates: "Affiliés",
        age_of_reviews: "Âge des Avis",
        agencies: "Agences",
        agency: "Agence",
        agency_name: "Nom de l'agence",
        agency_project: "Projet d'agence",
        agency_projects: "Projets d'agence",
        ai: "IA",
        ai_answers: "Réponses IA",
        ai_assistant: "Assistant IA",
        ai_auto_tagging: "Étiquetage IA",
        ai_highlights_instructions: "Exemple : Privilégier les phrases sur le service ou notre marque.",
        ai_reply_instructions: "Exemple : Gardez les réponses courtes. Invitez à nous contacter en cas d’avis négatif.",
        ai_review_instructions: "Exemple : Mentionnez le personnel et la visite. Ne mentionnez pas les prix.",
        ai_review_suggestions: "Suggestions d’avis IA",
        ai_reviews_and_replies: "Suggestions et réponses de l'IA",
        ai_tagging_instructions: "Exemple: Appliquer aux avis mentionnant des temps d’attente, un service lent ou des retards.",
        ai_tags: "Tags IA",
        ai_tools: "Outils IA",
        all: "Tous",
        allowed_domains: "Domaines autorisés",
        amount: "Montant",
        analytics: "Analytique",
        and: "et",
        anonymous_reviews: "Avis anonymes",
        answer: "Répondre",
        any: "N'importe lequel",
        api: "API",
        api_key: "Clé API",
        appearance: "Apparence",
        apply: "Appliquer",
        approved: "Approuvé",
        archive: "Archive",
        archive_customer: "Archiver le client",
        archived: "Archivé",
        at_least: "au moins",
        at_least_days: "Au moins {num} jours",
        at_least_hours: "Au moins {num} heures",
        at_least_months: "Au moins {num} mois",
        at_most: "au plus",
        at_most_days: "Au plus {num} jours",
        at_most_hours: "Au plus {num} heures",
        at_most_months: "Au maximum {num} mois",
        auth_token: "Jeton d'authentification",
        authorize: "Autoriser",
        auto_detect: "Auto",
        auto_tags: "Tags IA",
        automate: "Automatiser",
        automate_highlights: "Automatiser les surlignages",
        automate_replies: "Automatiser les réponses",
        automatic_review_collection: "Collecte automatique des Avis",
        automatically_apply_tags: "Appliquer automatiquement l'étiquette aux avis existants",
        automating: "Automatisation",
        avatar: "Avatar",
        avatars: "Avatars",
        average_charge: "Prélèvement moyen",
        average_review: "Avis moyenne",
        background_color: "Couleur d'arrière-plan",
        background_image: "Image d'arrière-plan",
        back: "Dos",
        bcc: "BCC",
        bcc_email_address: "Adresse e-mail BCC",
        best_to_worst: "Du meilleur au pire",
        billing: "Facturation",
        blog: "Blog",
        body: "Contenu",
        body_font_size: "Taille de la police du Contenu",
        bold: "Gras",
        book_a_demo: "Réserver une démo",
        bottom: "Bas",
        bottom_left: "En bas à gauche",
        bottom_right: "En bas à droite",
        build_on: "Basé sur {model}",
        business: "Business",
        business_description: "Description de l'entreprise",
        business_email: "Adresse e-mail d'assistance",
        business_name: "Nom de l'entreprise",
        business_phone: "Numéro de téléphone d'assistance",
        business_website: "Site Web d'entreprise",
        button: "Bouton",
        button_label: "Étiquette pour Bouton",
        button_link: "Lien pour le Bouton",
        button_position: "Position du Bouton",
        button_size: "Taille du Bouton",
        buy_me_a_coffee: "Offre-moi un café",
        by: "par",
        by_signing_up: "En créant un compte, vous acceptez nos conditions générales.",
        call_to_action: "Appel à l'action",
        cancel: "Annuler",
        cancel_1_message: "Annuler 1 message",
        cancel_message: "Annuler le message",
        cancel_messages: "Annuler les messages {count}",
        cancel_subscription: "Annuler l'abonnement",
        cancel_unsent_messages: "Annuler les messages non envoyés",
        canceled: "Annulé",
        center: "Centre",
        change: "Changement",
        change_key: "Modifiez votre clé API",
        change_plan: "Changer de plan",
        changelog: "Journal des modifications",
        channel: "Canal",
        channels: "Chaînes",
        characters: "Caractères",
        charges_avg: "Le prélèvement moyen doit être d'au moins",
        charges_count: "Le nombre de prélèvements doit être au moins",
        charges_sum: "Le total des prélèvements doit être d'au moins",
        chat_with_us: "Discutez avec nous",
        checkbox: "Case à cocher",
        claude: "Claude",
        clear: "Effacer",
        clear_highlights_from_reviews: "Supprimer les surlignages de tous les avis",
        clicked: "cliqué",
        client: "Client",
        client_id: "ID Client",
        clients: "Clients",
        close: "Fermer",
        cloudflare_warning: "Si vous utilisez Cloudflare, votre proxy doit être désactivé.",
        cname: "CNAME",
        cname_setup_incomplete: "Configuration incomplète - sera supprimée le {date}",
        cname_ssl_pending: "En attente du certificat SSL",
        cname_status_for: "Statut CNAME pour",
        code_editor: "Éditeur de code",
        collapse: "Réduire",
        collect_reviews_anywhere: "Collectez les avis partout",
        color: "Couleur",
        colors: "Couleurs",
        commission_rate: "Taux de commission",
        commission_status_approved: "Approuvé",
        commission_status_paid: "Payé",
        commission_status_pending: "En attente",
        commission_status_reversed: "Renversé",
        community: "Communauté",
        company: "Entreprise",
        complained: "Plainte",
        confirm_new_password: "Confirmer le nouveau mot de passe",
        confirmation_message: "Message de confirmation",
        configure: "Configurer",
        connect: "Connecter",
        connect_bank: "Connecter un compte bancaire",
        connect_google: "Connectez-vous à Google",
        connect_google_business_profile: "Connect Google Business Profile",
        connected: "Connecté",
        consent_preferences: "Préférences de consentement",
        contact_customer: "Contacter le client",
        contact_form: "Formulaire de contact",
        contact_support: "Veuillez contacter le support.",
        contact_us: "Contactez-nous",
        container_element: "Élément conteneur",
        context: "Contexte",
        continue: "Continuer",
        continue_with_google: "Continuer avec Google",
        cookie_category_analytics: "Analytique",
        cookie_category_essential: "Essentiel",
        cookie_category_functional: "Fonctionnel",
        cookie_category_marketing: "Commercialisation",
        cookie_consent_banner: "Bannière de consentement aux cookies",
        cookie_consent_scope_all: "Montrez à tout le monde",
        cookie_consent_scope_eea: "Afficher uniquement pour les visiteurs de l'EEE et du Royaume-Uni",
        cookie_consent_scope_none: "Ne pas afficher",
        cookie_policy: "Politique relative aux cookies",
        cookie_preference: "Préférences en matière de cookies",
        copied: "Copié",
        copied_message: "Message copié",
        copy: "Copie",
        copy_embed_code: "Copier le code d'intégration",
        copy_signature: "Copie de la Signature",
        copy_source_code: "Copier le code source",
        copy_to_all_ratings: "Copier vers toutes les notes",
        copy_uuid: "Copier UUID",
        create: "Créer",
        create_account: "Créer un compte",
        create_agency: "Créer une agence",
        create_cname: "Créez un enregistrement CNAME et pointez-le vers",
        create_external_link: "Créer un Lien externe",
        create_field: "Créer un champ",
        create_link: "Créer un Lien",
        create_location: "Créer un emplacement",
        create_project: "Créer un projet",
        create_qr_code: "Créer un code QR",
        create_review: "Créer un Avis",
        create_review_page: "Créer une Page d'Avis",
        create_signature: "Créer une signature",
        create_source: "Créer une source",
        create_space: "Créer un espace de travail",
        create_tag: "Créer une Étiquette",
        create_tag_rule: "Créer une règle Étiquette",
        create_webhook: "Créer un webhook",
        create_widget: "Créer un widget",
        crms: "CRMs",
        csv: "CSV",
        currency: "Devise",
        current_plan: "Plan actuel",
        current_year: "Année en cours",
        custom_field: "Champ personnalisé",
        custom_instructions: "Instructions personnalisées",
        custom_url: "URL personnalisée",
        customer: "Client",
        customer_name_convention: "Convention de nom du client",
        customer_reviews: "Avis des clients",
        customers: "Clients",
        customize: "Personnaliser",
        customize_review_page: "Personnaliser la Page d’Avis",
        daily: "Tous les jours",
        daily_email_requests: "Demandes quotidiennes par e-mail",
        daily_limit: "Limite quotidienne",
        daily_requests: "Demandes quotidiennes",
        daily_sms_requests: "Demandes SMS quotidiennes",
        dark: "Sombre",
        dashboard: "Tableau de bord",
        date: "Date",
        date_added: "Date d'ajout",
        date_canceled: "Date annulée",
        date_clicked: "Date de clic",
        date_complained: "Date de la plainte",
        date_delivered: "Date de livraison",
        date_failed: "Date d'échec",
        date_messaged: "Date du message",
        date_opened: "Date d'ouverture",
        date_replied: "Date de réponse",
        date_requested: "Date demandée",
        date_reviewed: "Date de l'avis",
        date_scheduled: "Date prévue",
        date_sent: "Date d'envoi",
        date_signed_up: "Date d'inscription",
        date_updated: "Date de mise à jour",
        dates: "Dates",
        day: "Jour",
        days: "Jours",
        days_after_last_request: "jours après la dernière demande",
        days_later: "quelques jours plus tard",
        deactivate: "Désactiver",
        default: "Défaut",
        default_language: "Langue par défaut",
        default_review_page: "Page d’Avis par défaut",
        default_review_visibility: "Visibilité des Avis par défaut",
        default_tone: "Tonalité par défaut",
        delay: "Retard",
        delete: "Supprimer",
        delete_1_customer: "Supprimer 1 client",
        delete_1_review: "Supprimer 1 Avis",
        delete_1_review_page: "Supprimer 1 Page d'avis",
        delete_1_widget: "Supprimer 1 widget",
        delete_agency: "Supprimer l'agence",
        delete_custom_field: "Supprimer le champ personnalisé",
        delete_customer: "Supprimer le client",
        delete_customers: "Supprimer les clients",
        delete_external_link: "Supprimer le Lien externe",
        delete_field: "Supprimer le champ",
        delete_link: "Supprimer le Lien",
        delete_location: "Supprimer l'emplacement",
        delete_message: "Supprimer le message",
        delete_n_customers: "Supprimer les clients {count}",
        delete_n_review_pages: "Supprimer les Pages d'avis {count}",
        delete_n_reviews: "Supprimer les Avis {count}",
        delete_n_widgets: "Supprimer les widgets {count}",
        delete_project: "Supprimer le projet",
        delete_qr_code: "Supprimer le code QR",
        delete_reply: "Supprimer la réponse",
        delete_review: "Supprimer Avis",
        delete_review_page: "Supprimer la Page d'Avis",
        delete_review_pages: "Supprimer les Pages d'Avis",
        delete_reviews: "Supprimer les Avis",
        delete_signature: "Supprimer la Signature",
        delete_source: "Supprimer la source",
        delete_space: "Supprimer Espace de travail",
        delete_tag: "Supprimer Étiquette",
        delete_tag_rule: "Supprimer la règle de Étiquette",
        delete_template: "Supprimer le modèle",
        delete_user: "Supprimer l'utilisateur",
        delete_webhook: "Supprimer le webhook",
        delete_widget: "Supprimer le widget",
        delete_widgets: "Supprimer les widgets",
        deleted: "Supprimé",
        delivered: "Livré",
        description: "Description",
        deselect_all: "Désélectionner tout",
        disable: "Désactiver",
        disable_automatic_review_collection: "Désactiver la collecte automatique des Avis",
        disable_field: "Désactiver le champ",
        disable_when_links_are_visible: "Désactiver lorsque les liens sont visibles",
        disabled: "Désactivé",
        disconnect: "Déconnecter",
        disconnect_integration: "Déconnecter l'intégration",
        discord_community: "Communauté Discord",
        display_name: "Nom d'affichage",
        dmarc: "DMARC",
        dmarc_status_for: "Statut DMARC pour",
        do_not_hide_from_public: "Ne pas masquer du public",
        do_not_send: "Ne pas envoyer",
        docs: "Documents",
        documentation: "Documentation",
        domain: "Domaine",
        domain_name: "Nom de domaine",
        dont_have_an_account: "Vous n’avez pas de compte ?",
        dont_send_thanks: "N'envoyez pas de remerciements",
        download: "Télécharger",
        download_records: "Télécharger les enregistrements",
        download_template: "Télécharger le modèle",
        dpa: "DPA",
        dsar: "DSAR",
        duplicate: "Dupliquer",
        duplicate_project: "Projet dupliqué",
        duplicate_review_page: "Page d'Avis en double",
        duplicate_reviews: "Avis en double",
        duplicate_widget: "Widget dupliqué",
        edit: "Modifier",
        edit_1_customer: "Modifier 1 client",
        edit_1_review: "Modifier 1 Avis",
        edit_client: "Modifier le Client",
        edit_custom_field: "Modifier le champ personnalisé",
        edit_customer: "Modifier le client",
        edit_customers: "Modifier les clients",
        edit_field: "Modifier le champ",
        edit_link: "Modifier le Lien",
        edit_location: "Modifier l'emplacement",
        edit_member: "Modifier le membre",
        edit_n_customers: "Modifier {count} Clients",
        edit_n_reviews: "Modifier {count} Avis",
        edit_notes: "Notes de modification",
        edit_qr_code: "Modifier le code QR",
        edit_reviews: "Modifier les Avis",
        edit_signature: "Modifier la Signature",
        edit_source: "Modifier la source",
        edit_strategy: "Modifier la stratégie",
        edit_tag: "Modifier la Étiquette",
        edit_tag_rule: "Règle de modification des Étiquette",
        edit_tags: "Modifier les étiquettes",
        edit_team_member: "Membre de l'équipe de modification",
        edit_visibility: "Modifier la visibilité",
        edit_webhook: "Modifier le webhook",
        editable_ratings: "Notes modifiables",
        earned: "Gagné",
        eligible: "Admissible",
        email: "E-mail",
        email_address: "Adresse email",
        email_validation_invalid: "La validation de l'e-mail a échoué",
        email_validation_passed: "Validation de l'e-mail réussie",
        email_validation_unknown: "L'e-mail n'a pas pu être vérifié",
        emails: "Courriels",
        embed_code: "Code d'intégration",
        enable: "Activer",
        enable_automatic_review_collection: "Activer la collecte automatique des Avis",
        enable_for_all_reviews: "Activer pour tous les avis",
        enable_for_positive_reviews: "Activer les avis positifs",
        enable_on_review_pages: "Activer sur les pages d'avis",
        enabled: "Activé",
        end: "Fin",
        ends: "Fin",
        exclude: "Exclure",
        exclude_email: "Exclure l'e-mail",
        exclude_sms: "Exclure les SMS",
        excluded_channels: "Chaînes exclues",
        expand: "Développer",
        expired: "Expiré",
        export: "Exporter",
        export_1_customer: "Exporter 1 client",
        export_1_review: "Exporter 1 Avis",
        export_all: "Exporter tout",
        export_all_customers: "Exporter tous les clients",
        export_all_reviews: "Exporter tous les Avis",
        export_customers: "Exporter les clients",
        export_n_customers: "Exporter {count} Clients",
        export_n_reviews: "Exporter {count} Avis",
        export_reviews: "Exporter les avis",
        external_link: "Lien externe",
        external_links: "Liens externes",
        extra_locations: "Emplacements supplémentaires",
        faces: "Visages",
        failed: "Échoué",
        feedback: "Retour",
        field: "Champ",
        fields: "Champs",
        filter: "Filtre",
        first: "D'abord",
        first_charged: "Premier prélèvement",
        first_name: "Prénom",
        first_name_last_initial: "Prénom, initiale du nom de famille",
        flag_as_duplicate: "Signaler comme doublon",
        font: "Police",
        font_family: "Famille de polices",
        font_size: "Taille de la police",
        footer: "Pied de page",
        for: "Pour",
        forgot_password: "Mot de passe oublié",
        form: "Formulaire",
        free: "Gratuit",
        free_requests_included: "Demandes gratuites incluses",
        from: "depuis",
        full_name: "Nom et prénom",
        generate: "Générer",
        generate_meta: "Générer des métadonnées",
        generate_qr_code: "Générer un code QR",
        generate_reply: "Générer une réponse",
        generate_review: "Générer un Avis",
        generating: "Génération en cours",
        get_started: "Commencer",
        get_started_checklist: "Liste de contrôle pour commencer",
        get_the_lifetime_deal: "Bénéficiez de l'offre à vie",
        getting_started: "Commencer",
        google_fonts: "Polices Google",
        grouped_by_request: "Groupé par requête",
        has_links: "A des Liens",
        has_notes: "Contient des notes",
        has_redirects: "A des redirections",
        have_an_account: "Vous avez un compte?",
        header: "En-tête",
        hidden: "Caché",
        hidden_from_search_engines: "Caché des moteurs de recherche",
        hidden_reviews: "Avis cachés",
        hide: "Cacher",
        hide_all_reviews: "Masquer tous les avis",
        hide_avatar: "Masquer l'avatar",
        hide_date: "Masquer la date",
        hide_drop_shadow: "Masquer l'ombre portée",
        hide_field_label: "Masquer l'étiquette du champ",
        hide_from_public: "Masquer du public",
        hide_name: "Masquer le nom",
        hide_pagination: "Masquer la pagination",
        highlight_color: "Couleur de surbrillance",
        hipaa: "HIPAA",
        host: "Hôte",
        hours: "Heures",
        icon: "Icône",
        icon_size: "Taille de l'icône",
        icons: "Icônes",
        id: "ID",
        image: "Image",
        import: "Importer",
        import_address1: "Ligne d’adresse du client 1.",
        import_address2: "Ligne d’adresse du client 2.",
        import_city: "La ville ou la localité du client.",
        import_company: "Le nom de l’entreprise du client.",
        import_created_at: "La date de l'avis.",
        import_customers: "Importer des clients",
        import_email: "L’adresse e-mail du client.",
        import_first_name: "Le prénom du client.",
        import_from_boost_space: "Importer depuis Boost.space",
        import_from_hubspot: "Importer depuis HubSpot",
        import_from_make_com: "Importer depuis Make.com",
        import_from_pabbly: "Importer depuis Pabbly",
        import_from_stripe: "Importer depuis Stripe",
        import_from_zapier: "Importer depuis Zapier",
        import_last_name: "Le nom de famille du client.",
        import_list: "Liste séparée par des virgules de",
        import_notes: "Notes à usage interne uniquement.",
        import_phone: "Le numéro de téléphone du client.",
        import_postal_code: "Le code postal du client.",
        import_recent_reviews: "Importer les Avis récents",
        import_review: "Le texte de l'avis.",
        import_reviews: "Importer les avis",
        import_score: "La note est de 1 à 5.",
        import_signed_up_at: "La date de début du client.",
        import_slug: "Le slug ou UUID d'un",
        import_state: "L’État ou la région du client.",
        import_yourself: "Vous importer",
        incentive: "Incitation",
        include: "Inclure",
        include_sample_reviews: "Inclure des exemples de avis",
        incoming_webhook_url: "URL du webhook entrant",
        inherit: "Hériter",
        initializing: "Initialisation",
        initials: "Initiales",
        install_in: "Installer dans",
        insert_variable: "Insérer une variable",
        instructions: "Instructions",
        integration: "Intégration",
        integrations: "Intégrations",
        interval: "Intervalle",
        introduction: "Introduction",
        invite: "Inviter",
        invite_client: "Inviter un Client",
        invite_failed: "L'invitation a échoué",
        invite_member: "Inviter un membre",
        invite_sent_to: "Invitation envoyée à",
        invite_team_member: "Inviter un membre de l'équipe",
        invited: "Invité",
        issuer_url: "URL de l'émetteur",
        italic: "Italique",
        joined: "Inscrit",
        key: "Clé",
        keywords: "Mots-clés",
        keywords_in_replies: "Mots-clés dans les réponses",
        keywords_in_reviews: "Mots-clés dans les Avis",
        kiosk_page: "Page du kiosque",
        label: "Étiquette",
        label_font_size: "Taille de la police de l'étiquette",
        labels: "Étiquettes",
        language: "Langue",
        languages: "Langues",
        large: "Grand",
        last_charged: "Dernier prélèvement",
        last_name: "Nom de famille",
        layout: "Mise en page",
        leave: "Partir",
        leave_project: "Quitter le projet",
        leave_space: "Quitter l'espace de travail",
        left: "Gauche",
        let_clients_sign_in_with_sso: "Permettre aux clients de se connecter avec SSO",
        less: "moins",
        lifecycle_stage: "Étape du cycle de vie",
        lifetime_deal: "Offre à vie",
        light: "Lumière",
        limit: "Limite",
        limits: "Limites",
        link: "Lien",
        link_color: "Couleur du lien",
        link_reveal_position: "Position d'affichage des liens",
        link_revealer_button: "Bouton révélateur de Lien",
        link_revealer_label: "Étiquette de révélation de Lien",
        link_revealer_rating: "Évaluation du révélateur de Lien",
        links: "Liens",
        links_per_review_page: "Liens par Page d’Avis",
        list: "Liste",
        list_unsubscribe_headers: "En-têtes List-Unsubscribe",
        load_more: "Charger plus",
        loading: "Chargement",
        location: "Emplacement",
        location_address: "Adresse du lieu",
        location_name: "Nom de l'emplacement",
        location_picker: "Sélecteur d'emplacement",
        locations: "Emplacements",
        locations_limit: "Limite d'emplacements",
        log_in: "Se connecter",
        log_out: "Se déconnecter",
        logo: "Logo",
        logo_height: "Hauteur du logo",
        long: "Long",
        lowest_rating: "Note la plus basse",
        ltd: "LTD",
        make_default: "Définir par défaut",
        manage: "Gérer",
        manage_limits: "Gérer les limites",
        manage_overrides: "Gérer les remplacements",
        manage_payout_account: "Gérer le compte de paiement",
        manage_subscription: "Gérer mon abonnement",
        manual_entry: "Saisie manuelle",
        max: "Max",
        max_size: "Taille maximale",
        maximum_characters: "Nombre maximal de Caractères",
        maximum_customers: "Nombre maximal de clients",
        maximum_locations: "Emplacements maximum",
        maximum_members: "Nombre maximum de membres",
        maximum_review_length: "Longueur maximale de l'avis",
        maximum_tags: "Nombre maximal de Étiquettes",
        maximum_widgets: "Nombre maximal de widgets",
        mcp: "Serveur MCP",
        mcp_server: "Serveur MCP",
        mcp_server_url: "URL du Serveur MCP",
        medium: "Moyen",
        member: "Membre",
        members: "Membres",
        menu: "Menu",
        message: "Message",
        message_link_expiration: "Expiration du Lien du message",
        messaged: "Message envoyé",
        messages: "Messages",
        messages_clicked: "Messages cliqués",
        messages_sent: "Messages envoyés",
        messaging_service_sid: "SID du service de messagerie",
        min: "Min",
        min_size: "Taille minimale",
        minimal_delay: "Délai minimal",
        minimum_characters: "Caractères minimum",
        minutes: "Minutes",
        month: "mois",
        monthly: "Mensuel",
        monthly_email_requests: "Demandes mensuelles par e-mail",
        monthly_limit: "Limite mensuelle",
        monthly_pricing_only: "Tarification mensuelle uniquement",
        monthly_request_limit: "Limite de demande mensuelle",
        monthly_requests: "Demandes mensuelles",
        monthly_sms_requests: "Demandes SMS mensuelles",
        months: "Mois",
        months_free: "{count} Mois gratuits",
        more: "plus",
        more_clients: "plus de clients",
        more_customers: "plus de clients",
        more_options: "Plus d'options",
        more_patients: "plus de patients",
        more_reviews: "plus avis",
        more_reviews_needed: "D'autres avis sont nécessaires pour résumer",
        more_users: "plus d'utilisateurs",
        more_visitors: "plus de visiteurs",
        most_negative: "Les plus négatifs",
        most_positive: "Les plus positifs",
        move: "Se déplacer",
        moved: "Déplacé",
        name: "Nom",
        native_reviews: "Avis natifs",
        negative_term: "Terme négatif",
        negative_trends: "Tendances négatives",
        new: "Nouveau",
        new_password: "Nouveau mot de passe",
        newest: "Plus récents",
        no: "Non",
        no_available_options: "Aucune option disponible",
        no_credit_card_required: "Aucune carte de crédit requise",
        no_data_available: "Aucune donnée disponible",
        no_negative_trends: "Aucune tendance négative pour le moment",
        no_positive_trends: "Aucune tendance positive pour le moment",
        no_reminders: "N'envoyez pas de rappels",
        no_retries: "Aucune nouvelle tentative",
        no_review: "Aucun avis",
        none: "Aucun",
        not_connected: "Non connecté",
        not_reviewed: "Non Avis publié",
        notes: "Notes",
        notifications: "Notifications",
        now: "Maintenant",
        n_1_ai_tag: "1 tag IA",
        n_1_review_page: "1 page d’avis",
        n_ai_tags: "{count} tags IA",
        n_review_pages: "{count} pages d’avis",
        number_of_charges: "Nombre de prélèvements",
        number_of_reminders: "Nombre de rappels",
        number_of_retries: "Nombre de tentatives",
        number_of_review_suggestions: "Nombre de suggestions d'avis",
        of: "de",
        off: "Désactivé",
        on: "Sur",
        on_for_positive_reviews: "Activé pour les avis positifs",
        on_channel: "sur la chaîne {channel}.",
        opened: "Ouvert",
        options: "Options",
        or_log_in_with_email: "ou connectez-vous avec votre adresse e-mail",
        or_sign_up_with_email: "ou utilisez votre adresse e-mail",
        our_reviews: "Nos Avis",
        output: "Sortir",
        page_footer: "Pied de page",
        paid: "Payé",
        paragraph: "Paragraphe",
        password: "Mot de passe",
        past_month: "Le mois dernier",
        past_months: "Derniers {inc} mois",
        past_week: "La semaine dernière",
        past_year: "Année écoulée",
        past_years: "Dernières {inc} années",
        paused: "En pause",
        payment_method: "Mode de paiement",
        payout_status_completed: "Complété",
        payout_status_pending: "En attente",
        pending: "En attente",
        pending_deployment: "Déploiement en attente",
        pending_validation: "En attente de validation",
        per_day: "par jour",
        per_month: "par mois",
        permissions: "Autorisations",
        phone: "Téléphone",
        phone_number: "Numéro de téléphone",
        pixels: "pixels",
        placeholder: "Espace réservé",
        placement: "Placement",
        plan: "Plan",
        plan_bullet1: "Supprimez notre marque sur les e-mails, les pages et les widgets",
        plan_bullet2: "Utilisez votre domaine pour les pages destinées aux clients et l'envoi d'e-mails",
        plan_bullet3: "Personnalisez votre produit grâce à la marque blanche pour les agences",
        please_rate_our_service: "Veuillez évaluer notre service",
        png: "PNG",
        policies: "Politiques",
        popular: "Populaire",
        port: "Port",
        position: "Position",
        positive_only: "Avis positifs uniquement",
        positive_term: "terme positif",
        positive_trends: "Tendances positives",
        powered_by: "Alimenté par",
        preview: "Aperçu",
        preview_kiosk_page: "Page de prévisualisation du kiosque",
        preview_review_page: "Aperçu de la Page d'Avis",
        price: "Prix",
        pricing: "Tarification",
        primary_color: "Couleur primaire",
        priority: "Priorité",
        privacy_policy: "politique de confidentialité",
        proceed_to_dashboard: "Accéder au tableau de bord",
        product: "Produit",
        profile: "Profil",
        project: "Projet",
        project_name: "Nom du projet",
        setup_ask_delay: "Combien de temps faut-il attendre avant de demander un avis?",
        setup_reminders: "Combien de rappels envoyer",
        project_paused: "Ce projet est suspendu.",
        project_suspended: "Ce projet est suspendu.",
        project_website: "Site Web du projet",
        projects: "Projets",
        projects_limit: "Limite des projets",
        publish: "Publier",
        publish_changes: "Publier les modifications sur toutes les autres pages d'avis",
        published: "Publié",
        purchase: "Achat",
        qr_code: "Code QR",
        qr_code_name_placeholder: "Table 1, Réception",
        qr_codes: "Codes QR",
        quantity: "Quantité",
        query: "Requête",
        quick_import: "Importation rapide",
        rating: "Note",
        rating_order: "Ordre de notation",
        rating_out_of: "note sur",
        rating_save_all: "Enregistrer la note avant chaque avis",
        rating_save_customer: "Enregistrer la note avant de laisser un avis client",
        rating_save_never: "Ne jamais enregistrer la note avant l'avis",
        rating_selection: "Sélection de notation",
        rating_selector: "Sélecteur de notation",
        ratings: "Notes",
        read: "Lire",
        reapply_highlights_eligible: "Régénérez les points forts grâce à l'IA pour tous les avis positifs",
        reconnect: "Reconnecter",
        redeem: "Racheter",
        redirect_uri: "URI de redirection",
        redirects: "Redirections",
        refer_and_earn: "Parrainez et gagnez",
        referral_billing_status_active: "Abonné",
        referral_billing_status_canceled: "Annulé",
        referral_billing_status_trial: "Essai",
        referral_billing_status_trial_expired: "Période d'essai expirée",
        referral_billing_status_trial_expiring: "Expiration de la période d'essai",
        referral_program: "Conditions générales du programme de parrainage",
        referral_program_terms: "Conditions générales du programme de parrainage",
        referrals: "Parrainages",
        refresh: "Rafraîchir",
        regenerate: "Régénérer",
        reject_all: "Tout refuser",
        related_reviews: "Avis similaires",
        related_similarity: "Similarité",
        remaining: "Restant",
        reminder: "Rappel",
        reminders: "Rappels",
        remove: "Retirer",
        remove_client: "Supprimer le Client",
        remove_cname: "Supprimer le CNAME",
        remove_domain: "Supprimer le domaine",
        remove_from_project: "Retirer du projet",
        remove_member: "Supprimer un membre",
        remove_smtp_configuration: "Supprimer la configuration SMTP",
        remove_team_member: "Supprimer un membre de l'équipe",
        rename: "Rebaptiser",
        rename_template: "Renommer le modèle",
        renews: "Renouvelle",
        replied: "Répondu",
        reply: "Répondre",
        reply_to: "Adresse de réponse",
        replying_on: "Répondre à",
        request: "Demande",
        request_1_review: "Demander 1 avis",
        request_date: "Date de la demande",
        request_n_reviews: "Demander {count} avis",
        request_review: "Demander un Avis",
        request_reviews: "Demander des Avis",
        requested: "Demandé",
        requested_review: "Avis demandé",
        requests: "Demandes",
        requests_left_this_month: "demandes laissées ce mois-ci",
        requests_remaining: "Demandes restantes",
        require_field: "Champ obligatoire",
        require_sso: "Exiger l'authentification unique (SSO)",
        required: "Requis",
        reschedule_message: "Reprogrammer le message",
        resend_invite: "Renvoyer l'invitation",
        reset_password: "Réinitialiser le mot de passe",
        restore: "Restaurer",
        restore_to_defaults: "Restaurer les paramètres par défaut",
        restore_widget: "Widget de restauration",
        resubscribe: "Se réabonner",
        resubscribe_customer: "Réabonnement client",
        resync: "Resynchronisation",
        resync_account: "Resynchroniser le compte",
        resync_now: "Resynchroniser maintenant",
        retries: "Tentatives",
        reveal_above_form: "Révéler le formulaire ci-dessus",
        reveal_after_submission: "Révéler après la soumission",
        reveal_below_form: "Révéler le formulaire ci-dessous",
        review: "Avis",
        review_length: "Longueur de l'avis",
        review_link: "Lien vers l'avis",
        review_missed: "Avis manqué",
        review_not_requested: "Avis non demandé",
        review_origin: "Cet avis provient du modèle",
        review_page: "Page d'avis",
        review_pages: "Pages d'avis",
        review_requested: "Avis demandé",
        review_spotlight: "Avis en vedette",
        review_suggestion: "Suggestion d'avis",
        review_suggestions: "Suggestions d'avis",
        review_text: "Texte de l'avis",
        review_wall: "Mur d'avis",
        reviewed: "Avis publié",
        reviews: "Avis",
        reviews_ask: "Demander",
        reviews_query_failed: "Une erreur s'est produite. Veuillez réessayer.",
        reviews_query_placeholder: "Consultez les avis ou posez une question...",
        reviews_with_highlights: "Avis avec points forts",
        reviews_with_replies: "Avis avec réponses",
        reviews_without_replies: "Avis sans réponses",
        revoke: "Révoquer",
        revoke_client: "Révoquer l'application",
        roadmap: "Feuille de route",
        role: "Rôle",
        sans_serif: "Sans Serif",
        save: "Enregistrer",
        save_preferences: "Enregistrer les préférences",
        save_template: "Enregistrer le modèle",
        save_template_as_new: "Enregistrer un nouveau modèle",
        saved: "Enregistré",
        schedule: "Calendrier",
        schedule_review_request: "Demande d'avis",
        scheduled: "Programmé",
        score: "Score",
        search: "Recherche",
        second: "Deuxième",
        secret_key: "Clé secrète",
        sections: "Sections",
        security_code: "Code de sécurité",
        select: "Sélectionner",
        select_account: "Sélectionnez un compte",
        select_all: "Tout sélectionner",
        select_an_option: "Sélectionnez une option",
        select_bulk_action: "Sélectionner une action en masse",
        select_csv_file: "Sélectionnez le fichier CSV",
        select_date: "Sélectionnez la date",
        select_field: "Sélectionnez un champ",
        select_icon: "Sélectionnez une icône",
        select_location: "Sélectionnez un emplacement",
        select_plan: "Choisissez un forfait",
        select_review: "Sélectionnez un Avis",
        select_source: "Sélectionnez une source",
        select_tag: "Sélectionnez une Étiquette",
        selected: "Choisi",
        send: "Envoyer",
        send_1_reminder: "Envoyer 1 rappel",
        send_2_reminders: "Envoyer 2 rappels",
        send_3_reminders: "Envoyer 3 rappels",
        send_anytime: "Envoyer à tout moment",
        send_between: "Envoyer entre",
        send_message: "Envoyer un message",
        send_retries: "Tentatives d'envoi {count}",
        send_retry: "Envoyer {count} Réessayer",
        send_test: "Envoyer un test",
        send_thanks: "Envoyer des remerciements",
        sender_email_address: "Adresse e-mail de l'expéditeur",
        sender_id: "ID de l'expéditeur",
        sender_name: "Nom de l'expéditeur",
        sending_domain: "Domaine d'envoi",
        sentiment: "Sentiment",
        sent: "Envoyé",
        sent_replies: "Réponses envoyées",
        serif: "Serif",
        set_up: "Configurer",
        settings: "Paramètres",
        share: "Partager",
        share_link: "Partager le Lien",
        short: "Court",
        show: "Montrer",
        show_1_suggestion: "Afficher 1 suggestion",
        show_100_results: "Afficher 100 résultats",
        show_2_suggestions: "Afficher 2 suggestions",
        show_25_results: "Afficher 25 résultats",
        show_3_suggestions: "Afficher 3 suggestions",
        show_4_suggestions: "Afficher 4 suggestions",
        show_5_suggestions: "Afficher 5 suggestions",
        show_50_results: "Afficher 50 résultats",
        show_all_reviews: "Afficher tous les avis",
        show_arrows: "Afficher les flèches",
        show_avatar: "Afficher l'avatar",
        show_cookie_consent_banner: "Afficher la bannière de consentement aux cookies",
        show_date: "Afficher la date",
        show_dots: "Afficher les points",
        show_drop_shadow: "Afficher l'ombre portée",
        show_field: "Afficher le champ sur les notes suivantes",
        show_full: "Afficher toutes les étoiles",
        show_photo: "Afficher la photo uniquement",
        show_positive_reviews: "Afficher uniquement les avis positifs",
        show_to_public: "Montrer au public",
        showcase: "Showcase",
        showcase_page: "Page de présentation",
        sign_up: "S'inscrire",
        sign_up_for_free: "Inscrivez-vous gratuitement",
        sign_up_with_email: "S'inscrire par e-mail",
        sign_in_with_sso: "Se connecter avec l'authentification unique",
        sign_up_with_google: "S'inscrire avec Google",
        signature: "Signature",
        signatures: "Signatures",
        signed_up: "Inscrit",
        since: "Depuis",
        size: "Taille",
        skip: "Sauter",
        slug: "Slug",
        small: "Petit",
        sms: "SMS",
        smtp_configuration: "Configuration SMTP",
        sort: "Trier",
        source: "Source",
        source_code: "Code source",
        sources: "Sources",
        space: "Espace de travail",
        space_name: "Nom de Espace de travail",
        spaces: "Espaces de travail",
        split: "Diviser",
        sso: "SSO",
        star_color: "Couleur des étoiles",
        stars: "Étoiles",
        start: "Commencer",
        start_free_trial: "Essai gratuit",
        start_getting_more_reviews: "Commencez à obtenir plus Avis",
        status: "Statut",
        store_code: "Code du magasin",
        strategy: "Stratégie",
        sub_processors: "Sous-processeurs",
        subject: "Sujet",
        subscribe: "S'abonner",
        subscription: "Abonnement",
        success_page: "Page de réussite",
        suggestion: "Suggestion",
        suggestions: "Suggestions",
        summary: "Résumé",
        support: "Assistance",
        suspend: "Suspendre",
        suspend_project: "Suspendre le projet",
        suspended: "Suspendu",
        svg: "SVG",
        switch_to_smtp_setup: "Passer à la configuration SMTP",
        switch_to_standard_setup: "Passer à la configuration standard",
        symbol: "Symbole",
        sync: "Synchronisation",
        sync_account: "Compte de synchronisation",
        sync_now: "Synchroniser maintenant",
        sync_scheduled_time: "Synchronisation planifiée {time}",
        sync_with_facebook: "Synchroniser avec Facebook",
        sync_with_google: "Synchroniser avec Google",
        synced_time: "Synchronisé {time}",
        system: "Système",
        system_fonts: "Polices système",
        tag: "Étiquette",
        tag_1_customer: "Étiquette 1 Client",
        tag_1_review: "Étiquette Avis",
        tag_customers: "Étiqueter les clients",
        tag_existing_reviews: "Étiquette des Avis existants",
        tag_n_customers: "Étiquette {count} Clients",
        tag_n_reviews: "Étiqueter {count} avis",
        tag_reviews: "Étiqueter les avis",
        tag_rule: "Règle de balise",
        tag_with_ai: "Étiquette avec IA",
        tags: "Étiquettes",
        tags_for_customers: "Étiquettes pour les clients",
        tags_for_reviews: "Étiquettes pour les Avis",
        team: "Équipe",
        team_member: "Membre de l'équipe",
        team_members: "Membres de l'équipe",
        template: "Modèle",
        templates: "Modèles",
        terms_of_service: "Conditions d'utilisation",
        test_template: "Modèle de test",
        tests: "Tests",
        text: "Texte",
        text_alignment: "Alignement du texte",
        text_color: "Couleur du texte",
        thank_you_messages: "Messages de remerciement",
        thanks: "Merci",
        theme: "Thème",
        third: "Troisième",
        time_zone: "Fuseau horaire",
        timeframe: "Laps de temps",
        title: "Titre",
        tone: "Ton",
        top: "Haut",
        top_left: "En haut à gauche",
        top_right: "En haut à droite",
        total_charges: "Total des frais",
        total_reviews: "Total des Avis",
        trigger: "Déclenchement",
        trigger_charged: "Envoyer une demande après un prélèvement",
        trigger_created: "Envoyer la demande après l’inscription",
        try_free: "Essai gratuit",
        try_it_free: "Essayez-le gratuitement",
        type: "Type",
        types: "Types",
        unarchive: "Déarchiver",
        unarchive_customer: "Désarchiver le client",
        underline: "Souligner",
        unflag_as_duplicate: "Ne plus signaler comme doublon",
        unknown: "Inconnu",
        unlimited: "illimité",
        unnamed: "Anonyme",
        unpublish: "Dépublier",
        unpublished: "Inédit",
        unreplied: "Sans réponse",
        unsent_messages: "Messages non envoyés",
        unsubscribe: "Se désabonner",
        unsubscribe_1_customer: "Désabonner 1 client",
        unsubscribe_customer: "Désabonnement du client",
        unsubscribe_customers: "Désinscription des clients",
        unsubscribe_n_customers: "Désabonner {count} clients",
        unsubscribe_text: "Texte de désabonnement",
        unsubscribed: "Désabonné",
        unsuspend: "Réactiver",
        unsuspend_project: "Relancer le projet",
        unverified: "Non vérifié",
        update: "Mise à jour",
        update_password: "Mettre à jour le mot de passe",
        update_plan: "Plan de mise à jour",
        update_share_template: "Modèle de mise à jour",
        updated: "Mis à jour",
        updates: "Mises à jour",
        upgrade: "Mise à niveau",
        upgrade_for_more: "Passez à la version supérieure",
        upgrade_to_use: "Veuillez effectuer une mise à niveau pour utiliser cette fonctionnalité",
        upload: "Télécharger",
        upload_csv: "Importer un CSV",
        upload_icon: "Télécharger une icône",
        url: "URL",
        use: "Utiliser",
        use_filters_for_aggregate: "Utiliser des filtres pour l'agrégat",
        user: "Utilisateur",
        user_id: "ID de l'utilisateur",
        user_info: "Informations utilisateur",
        username: "Nom d'utilisateur",
        utc: "UTC",
        validate: "Valider",
        validate_customer_email: "Valider l'e-mail du client",
        validation: "Validation",
        validations: "Validations",
        value: "Valeur",
        verify: "Vérifier",
        verify_email_address: "Vérifier l'adresse e-mail",
        view: "Voir",
        view_all: "Afficher tout",
        view_all_features: "Afficher toutes les fonctionnalités",
        view_available_fields: "Afficher les champs disponibles",
        view_documentation: "Consulter la documentation",
        view_email_templates: "Afficher les modèles d'e-mails",
        view_review_pages: "Afficher les Pages d’Avis",
        view_reviews: "Voir les Avis",
        view_settings: "Afficher les paramètres",
        view_setup_guide: "Consultez le guide d'installation",
        view_showcase: "Voir la vitrine",
        view_strategy: "Voir la stratégie",
        visibility: "Visibilité",
        visible: "Visible",
        visible_reviews: "Avis visibles",
        visible_to_search_engines: "Visible pour les moteurs de recherche",
        wait_between_reminders: "Attendez entre les rappels",
        wait_period: "Période d'attente",
        webhook: "Webhook",
        webhooks: "Webhooks",
        website: "Site web",
        weekly: "Hebdomadaire",
        weeks: "Semaines",
        widget: "Widget",
        widgets: "Widgets",
        with_ai: "avec l'IA",
        worst_to_best: "Du pire au meilleur",
        write: "Écrire",
        written_reviews: "Avis écrits",
        year: "année",
        yearly: "Annuel",
        yes: "Oui",
        your_referral_link: "Votre Lien de parrainage"
    },
    landing: {
        announcement: "Obtenez des rapports de réputation avec notre serveur MCP",
        counter: "Rejoignez plus de 5 000 entreprises locales de services",
        counter_agencies: "Utilisé par plus de 500 agences pour la gestion des avis",
        counter_ai: "Gérer sa réputation depuis Claude et ChatGPT",
        ai_screen_1_badge: "MCP",
        ai_screen_1_bullets: [
            "Obtenez des réponses sans vous connecter à un autre tableau de bord",
            "Agissez sur votre réputation dans les outils de messagerie que votre équipe utilise déjà.",
            "Enregistrer des heures chaque semaine en posant des questions au lieu de creuser."
        ],
        ai_screen_1_subtitle: "La gestion de votre réputation doit s'adapter à votre façon de penser. Demandez à Claude ou ChatGPT ce qui nécessite une réponse, à qui s'adresser ensuite ou comment s'est passée votre semaine, et obtenez des réponses en direct sans changer d'outil.",
        ai_screen_1_title: "Demandez à Claude ou à ChatGPT",
        ai_screen_2_badge: "Réponses de l'IA",
        ai_screen_2_bullets: [
            "Répondre plus rapidement sans paraître générique",
            "Ne laissez jamais avis sans réponse lorsque vous êtes occupé(e).",
            "Protégez l'image de votre marque dans chaque réponse publique"
        ],
        ai_screen_2_subtitle: "Chaque avis sans réponse représente une occasion manquée de gagner la confiance de vos clients. L'IA rédige des réponses qui vous ressemblent, vous permettant ainsi de résorber votre attente en quelques minutes et de rester disponible pour vos clients sans la corvée de la rédaction.",
        ai_screen_2_title: "Répondre sans détour",
        ai_screen_3_badge: "Suggestions de l'IA",
        ai_screen_3_bullets: [
            "Amener plus de clients à franchir la ligne d'arrivée",
            "Recueillir des commentaires spécifiques et partageables",
            "Transformez les visites réussies en avis dignes d'être partagés."
        ],
        ai_screen_3_subtitle: "La plupart des gens ont l'intention de laisser un avis, mais ne le font jamais. Fournissez-leur des instructions claires et précises, rédigées dans votre style, afin qu'ils soient plus enclins à finaliser leur commentaire et que celui-ci soit suffisamment percutant pour être mis en valeur.",
        ai_screen_3_title: "Obtenez plus avis 5 étoiles",
        ai_screen_4_badge: "Étiquetage IA",
        ai_screen_4_bullets: [
            "Repérez les tendances avant qu'elles ne deviennent des problèmes.",
            "Identifiez les thèmes qui influencent réellement les audiences.",
            "Évitez de lire des centaines d' avis à la main"
        ],
        ai_screen_4_subtitle: "Vous ne devriez pas avoir à relire chaque avis pour savoir ce qui se passe. L'IA organise les commentaires par thèmes, ce qui vous permet de corriger les problèmes plus rapidement et de vous concentrer sur ce que les clients apprécient.",
        ai_screen_4_title: "Sachez ce que disent les clients",
        ai_summary_1_desc: "Préparez des réponses Google et Facebook qui correspondent à votre ton, ou programmez des réponses automatiques.",
        ai_summary_1_title: "Réponses de l'IA",
        ai_summary_2_desc: "Fournissez à vos clients des suggestions d'avis prêtes à l'emploi lorsqu'ils laissent un commentaire sur votre page.",
        ai_summary_2_title: "Suggestions d'évaluation de l'IA",
        ai_summary_3_desc: "Mettez en avant les meilleures phrases des avis positifs sur les widgets, présentez-les et partagez des images.",
        ai_summary_3_title: "Points saillants de l'IA",
        ai_summary_4_desc: "Appliquez les étiquettes issues des règles que vous définissez afin que des thèmes tels que les temps d'attente ou la qualité du service restent organisés.",
        ai_summary_4_title: "Étiquetage automatique par IA",
        ai_summary_5_desc: "Recevez des résumés concis des avis récents, avec le nombre d'avis, les thèmes abordés et les points à prendre en compte.",
        ai_summary_5_title: "Résumés des Avis",
        ai_summary_6_desc: "Repérez les éloges croissants et les plaintes émergentes sans lire chaque avis manuellement.",
        ai_summary_6_title: "Tendances positives et négatives",
        ai_summary_7_desc: "Trouvez des avis similaires à côté de chaque commentaire afin de repérer facilement les tendances et les répétitions.",
        ai_summary_7_title: "avis connexes",
        ai_summary_8_desc: "Posez des questions en langage clair concernant vos avis et obtenez des réponses avec des références que vous pouvez ouvrir.",
        ai_summary_8_title: "Demandez à l'IA",
        ai_summary_9_desc: "Connectez Claude, ChatGPT et d'autres clients MCP pour gérer la réputation dans le chat.",
        ai_summary_9_title: "MCP pour assistants",
        ai_summary_10_desc: "Obtenez des rapports de réputation en direct couvrant le volume, les évaluations, les emplacements, les réponses et la sensibilisation.",
        ai_summary_10_title: "rapports de réputation",
        ai_summary_11_desc: "Ton guide, mots-clés et instructions personnalisées pour que chaque sortie de l'IA reflète votre marque.",
        ai_summary_11_title: "IA consciente de la marque",
        ai_summary_12_desc: "Évaluez à quel point les avis écrits sont positifs ou négatifs, au-delà des étoiles, pour trier ce qui demande attention.",
        ai_summary_12_title: "Sentiment",
        industries: {
            accountants: "Comptables",
            auto_repair: "Mécaniciens auto",
            chiropractors: "Chiropracteurs",
            cleaning: "Agents d'entretien",
            contractors: "Entrepreneurs",
            dentists: "Dentistes",
            doctors: "Médecins",
            electricians: "Électriciens",
            financial_advisors: "Conseillers financiers",
            hvac: "Techniciens CVC",
            insurance_brokers: "Courtiers d'assurance",
            landscapers: "Paysagistes",
            law_firms: "Avocats",
            locksmiths: "Serruriers",
            mortgage_brokers: "Courtiers hypothécaires",
            optometrists: "Optométristes",
            personal_trainers: "Coach sportifs",
            pest_control: "Exterminateurs",
            physical_therapists: "Kinésithérapeutes",
            plumbers: "Plombiers",
            real_estate: "Agents immobiliers",
            restaurants: "Restaurateurs",
            salons: "Coiffeurs",
            self_storage: "Exploitants de self-stockage",
            spas: "Esthéticiens",
            tour_guides: "Guides touristiques",
            veterinarians: "Vétérinaires"
        },
        industries_title: "Gestion des avis pour les entreprises de services locales",
        stat_1_article: "Rapport d'étude de consommation",
        stat_1_desc: "Les consommateurs souhaitent lire plus de 100 avis avant de faire confiance à une entreprise en ligne.",
        stat_1_source: "Salsif",
        stat_1_title: "Les Avis inspirent confiance",
        stat_2_article: "Enquête locale Avis des consommateurs",
        stat_2_desc: "Les consommateurs qui comparent les commerces locaux préfèrent ceux qui répondent à tous les avis.",
        stat_2_source: "BrightLocal",
        stat_2_title: "Choisissez qui répond",
        stat_3_article: "Avis, réputation et revenus",
        stat_3_desc: "Une petite augmentation de votre note peut se traduire par une réelle hausse de vos revenus.",
        stat_3_source: "École de commerce de Harvard",
        stat_3_title: "Revenu par étoile",
        stat_4_article: "Dépendance des consommateurs aux résultats de recherche IA",
        stat_4_desc: "Lorsque les internautes demandent à l'IA qui choisir, vos avis contribuent à rédiger la réponse.",
        stat_4_source: "Bain & Company",
        stat_4_title: "S'appuyer sur la recherche par IA",
        subtitle: "Demandez des avis automatiquement. Obtenez plus de notes 5 étoiles et surpassez vos concurrents.",
        agencies_screen_1_badge: "Portail",
        agencies_screen_1_bullets: [
            "Vendez un portail de marque avec chaque contrat.",
            "Gardez vos clients au sein de votre écosystème, pas via une connexion tierce.",
            "Ressembler à une entreprise de logiciels, sans en construire une."
        ],
        agencies_screen_1_subtitle: "Offrez à chaque client un portail qui ressemble à un produit que vous avez construit : votre logo, vos couleurs, votre domaine. Puis packager la gestion des avis comme un service récurrent auquel ils se connectent chaque mois. Vous ne recommandez pas un outil. Vous en livrez un.",
        agencies_screen_1_title: "Un portail qu’ils croient avoir été construit par vous",
        agencies_screen_2_badge: "Contrôle",
        agencies_screen_2_bullets: [
            "Associez les fonctionnalités aux formules de base, de croissance et premium",
            "Invitez les bonnes personnes et contrôlez ce que chaque client voit.",
            "Remplacer les demandes, les emplacements et les limites par projet"
        ],
        agencies_screen_2_subtitle: "Tous les clients n’ont pas besoin de tout. Invitez des équipes à des projets précis, définissez des rôles et surchargez fonctionnalités et limites par compte pour que vos offres correspondent à votre facturation. Upsellez l’accès à mesure qu’ils grandissent, sans builds sur mesure pour chaque pack.",
        agencies_screen_2_title: "Contrôlez l’accès par client",
        agencies_screen_3_badge: "IA",
        agencies_screen_3_bullets: [
            "Proposez des réponses IA qui enregistrer des heures à vos clients chaque semaine.",
            "Connectez Claude ou d'autres assistants via le MCP de chaque projet.",
            "Intégrer l'IA comme module complémentaire premium pour les clients"
        ],
        agencies_screen_3_subtitle: "Ne vous contentez pas de gérer les avis. Donnez aux clients une IA qui rédige des réponses, tague les retours et fonctionne via Claude ou d’autres assistants grâce au serveur MCP du projet. C’est une capacité moderne que les agences peuvent packager, upseller et renouveler, sans équipe de contenu pour chaque compte.",
        agencies_screen_3_title: "Une IA pour laquelle les clients paieront",
        agencies_screen_4_badge: "Échelle",
        agencies_screen_4_bullets: [
            "Gérez les avis de plusieurs entreprises depuis un seul compte.",
            "Ajoutez des emplacements au fur et à mesure que vous en remportez, avec des tarifs dégressifs.",
            "Transformez chaque nouveau client en revenu récurrent"
        ],
        agencies_screen_4_subtitle: "Un siège agence. Des dizaines d’entreprises. Gérez collecte d’avis, réponses et reporting sur chaque établissement client depuis un hub unique, puis augmentez la marge en ajoutant des comptes. C’est ainsi que les agences transforment la réputation en flux de revenus scalable, pas en projet ponctuel.",
        agencies_screen_4_title: "Scalez sur chaque client",
        agencies_summary_10_desc: "Mettez Claude ou d'autres assistants en relation pour gérer les projets, les clients et l'équipe.",
        agencies_summary_10_title: "Agence MCP",
        agencies_summary_11_desc: "Chaque client bénéficie de la suite complète d'outils d'évaluation: collection, IA, widgets, et bien plus encore.",
        agencies_summary_11_title: "Tout dans le monde des affaires",
        agencies_summary_12_desc: "Faites appel à une équipe qui comprend les flux de travail des agences et les déploiements clients.",
        agencies_summary_12_title: "Soutien dédié",
        agencies_summary_1_desc: "Les Clients gèrent leur réputation via un portail qui ressemble à un produit que vous avez vous-même créé.",
        agencies_summary_1_title: "Portail client de marque",
        agencies_summary_2_desc: "Hébergez le portail sur votre domaine afin que chaque connexion reste associée à votre marque.",
        agencies_summary_2_title: "domaine d'agence personnalisée",
        agencies_summary_3_desc: "Permettez à vos clients de se connecter avec votre fournisseur d'identité en un seul clic.",
        agencies_summary_3_title: "Authentification unique",
        agencies_summary_4_desc: "Invitez les clients à consulter des projets spécifiques et contrôlez ce qu'ils peuvent voir.",
        agencies_summary_4_title: "Invitations et rôles des Client",
        agencies_summary_5_desc: "Limitez les demandes, les emplacements et les fonctionnalités par projet pour correspondre à vos forfaits.",
        agencies_summary_5_title: "Remplacements par projet",
        agencies_summary_6_desc: "Donnez à votre équipe interne un accès complet à tous les projets clients.",
        agencies_summary_6_title: "sièges de l'équipe de l'agence",
        agencies_summary_7_desc: "Commencez par 5 emplacements, puis ajoutez-en d'autres en bénéficiant de tarifs dégressifs au fur et à mesure de votre croissance.",
        agencies_summary_7_title: "échelle multi-sites",
        agencies_summary_8_desc: "Notifications système envoyées depuis le domaine de votre agence, et par projet lorsque les clients n'ont pas ajouté les leurs.",
        agencies_summary_8_title: "envoi en marque blanche",
        agencies_summary_9_desc: "Automatisez vos projets, vos clients et votre équipe grâce à l' API Agency.",
        agencies_summary_9_title: "API d'agence",
        demo_footer: "Choisissez un créneau qui vous convient. Nous vous guiderons et répondrons à vos questions.",
        desc_contact: "Vous avez une question ou besoin d’aide ? Envoyez un message ci-dessous et nous nous en occupons.",
        mcp_aria: "Démonstration d'assistant IA connecté à More Good Reviews via MCP",
        mcp_prompts_aria: "Exemples de messages",
        review_flow_aria: "Carrousel de cartes affichant les demandes d'avis par e-mail, la page d'avis, les avis Google et les commentaires privés",
        review_flow_autopilot: "Fonctionne en mode automatique",
        review_flow_card_email_desc: "Une fois votre interaction avec un client terminée, nous vous envoyons automatiquement par e-mail une demande personnalisée contenant un lien direct vers votre page d'avis.",
        review_flow_card_email_title: "Envoyer la demande",
        review_flow_card_feedback_desc: "Les notes les plus basses donnent d'abord lieu à des commentaires privés, ce qui vous permet de rectifier le tir. Les Clients peuvent toujours choisir de publier un avis public.",
        review_flow_card_feedback_title: "Accepter les commentaires difficiles",
        review_flow_card_google_desc: "Les clients satisfaits disposent d'un moyen simple de laisser un avis public sur Google , de sorte que les éloges apparaissent là où les nouveaux clients les consultent.",
        review_flow_card_google_title: "Félicitez Google",
        review_flow_card_review_desc: "Ils arrivent sur votre page d'avis, choisissent une note, et l'étape suivante dépend du déroulement des choses.",
        review_flow_card_review_title: "Le Client choisit une note",
        review_flow_next: "Étape suivante",
        review_flow_prev: "Étape précédente",
        review_flow_step_email: "Demande un Avis",
        review_flow_step_feedback: "ou demandez des commentaires",
        review_flow_step_google: "Itinéraire vers n'importe quel site Avis",
        review_flow_step_review: "Demander une Note",
        review_flow_steps_aria: "Étapes de la demande Avis",
        summary_10_desc: "Organisez vos clients et avis afin de pouvoir filtrer et agir rapidement.",
        summary_10_title: "Étiquetage des Client et des avis",
        summary_11_desc: "Zapier intègre More Good Reviews aux outils que vous utilisez déjà.",
        summary_11_title: "Se connecter à n'importe quelle application",
        summary_12_desc: "Gérez votre réputation depuis Claude, ChatGPT et d'autres clients MCP .",
        summary_12_title: "MCP pour assistants IA",
        summary_1_desc: "Envoi programmé d'e-mails et de SMS avec rappels, en mode automatique.",
        summary_1_title: "Demandes de révision automatiques",
        summary_2_desc: "Des e-mails et des SMS qui correspondent à votre marque, à votre ton et à votre offre.",
        summary_2_title: "Modèles de marque",
        summary_3_desc: "Recueillez des commentaires privés ou orientez les gens vers Google, Facebook, et plus encore.",
        summary_3_title: "Pages de Avis",
        summary_4_desc: "Codes imprimables et collection plein écran en magasin.",
        summary_4_title: "codes QR et borne interactive",
        summary_5_desc: "Intégrez les notes et les avis n'importe où sur votre site web.",
        summary_5_title: "widgets de site Web",
        summary_6_desc: "Une page publique et personnalisable pour vos meilleurs avis.",
        summary_6_title: "Page Showcase",
        summary_7_desc: "Importer les avis et répondez-y depuis un seul endroit.",
        summary_7_title: "Synchronisation Google et Facebook",
        summary_8_desc: "Suggestions sur la page pour aider les clients à laisser un avis.",
        summary_8_title: "Aide à la rédaction de critiques par l'IA",
        summary_9_desc: "Rédigez des réponses, des résumés, des tendances et posez des questions à l'IA sur vos avis.",
        summary_9_title: "Réponses et analyses de l'IA",
        subtitle_agencies_feature_summary: "Portail en marque blanche, accès clients, scale et automatisation sous votre marque.",
        subtitle_ai_feature_summary: "Réponses, étiquetage, analyses et assistants intégrés à votre flux de travail de gestion de la réputation.",
        subtitle_feature_summary: "Collecte, affichage, IA et intégrations — prêts quand vous l’êtes.",
        subtitle_mcp: "Connectez Claude, ChatGPT et d’autres clients MCP, puis posez des questions sur les avis, les établissements et la prospection en langage naturel.",
        subtitle_review_flow: "Demandez des avis automatiquement. Les clients peuvent laisser un avis public à tout moment. Le feedback privé est optionnel.",
        title: "Gestion de réputation IA pour",
        title_agencies: "Transformez les avis en",
        title_agencies_feature_summary: "Tout ce dont les agences ont besoin",
        title_agencies_phrases: {
            branded_product: "un produit de marque qui vous appartient",
            recurring_retainers: "des retenues mensuelles récurrentes",
            revenue_stream: "une nouvelle source de revenus"
        },
        title_ai: "Demandez à votre IA",
        title_ai_feature_summary: "Tout ce que l'IA peut faire pour vous",
        title_ai_phrases: {
            weekly_report: "pour un rapport hebdomadaire sur la réputation",
            send_from_chat: "envoyer des demandes d'avis",
            next_steps: "pour les prochaines étapes à suivre"
        },
        title_contact: "Comment pouvons-nous vous aider?",
        title_faq: "Questions courantes",
        title_feature_summary: "Tout dans la boîte",
        title_footer: "Arrêtez de courir après les avis. Commencez à en obtenir.",
        title_footer_ai: "à propos de votre réputation",
        title_ltd: "Payez une fois et utilisez-le pour toujours avec notre offre à vie à durée limitée",
        title_mcp: "Demandez à l’IA votre réputation",
        title_review_flow: "Transformez de belles expériences en avis",
        title_phrases: {
            autopilot: "demander des avis en automatique",
            google_reviews: "obtenir plus d'avis Google",
            suggested_by_chatgpt: "être suggéré par ChatGPT"
        },
        title_pricing: "Toutes les fonctionnalités. Tarification simple.",
        title_reviews: "Découvrez pourquoi nous sommes n°1 en gestion d’avis"
    },
    plans: {
        agency: {
            agency_api: "API d'agence",
            branded_portal: "Portail client de marque",
            client_invites: "Invitations Client , rôles et dérogations",
            custom_domain: "domaine d'agence personnalisée",
            everything_in_business: "Plan d'affaires complet",
            locations_included: "5 emplacements inclus",
            review_requests: "5000 demandes d’avis par lieu et par mois",
            sso: "Authentification unique (SSO)",
            support: "Assistance clientèle dédiée",
            volume_pricing: "Tarifs dégressifs à partir de 49 $\/mois"
        },
        business: {
            ai: "Réponses, analyses et questions de l'IA",
            api_mcp: "Serveur API et MCP",
            custom_domains: "Domaines personnalisés pour les e-mails et les pages d'avis",
            google_facebook: "Profil Google Business et Facebook",
            locations_included: "1 emplacement inclus",
            review_requests: "Demandes d'avis {count} \/ lieu \/ mois",
            support: "Assistance clientèle dédiée",
            unlimited_customers: "Clients illimités",
            volume_pricing: "Tarifs dégressifs à partir de 99 $\/mois"
        },
        descriptions: {
            agency: "Pour les agences gérant la réputation de leurs clients sous leur marque. Cinq emplacements inclus avec des tarifs de gros évolutifs, plus un portail de marque et un accès client.",
            business: "Pour les entreprises qui gèrent leur propre réputation. Payez par emplacement avec des remises sur volume et bénéficiez de l'IA, des intégrations et d'un nombre illimité de clients inclus."
        },
        selectors: {
            agency_included: "Emplacements inclus (V0)",
            agency_tier: "+{from}–{to} emplacements · {price}\/{month} chacun",
            agency_tier_plus: "+{from}+ emplacements · {price}\/{month} chacun",
            business_tier: "emplacements {from}–{to} · chacun {price}\/{month}",
            business_tier_plus: "{from}+ emplacements · {price}\/{month} chacun"
        }
    },
    mcp_example_prompts: {
        labels: {
            add_customer_and_ask: "Ajouter un client et demander un avis",
            customers_to_ask: "Trouvez des clients à qui demander des avis",
            location_leaderboard: "Comparer les performances de localisation",
            outreach_health: "Auditer la santé de la diffusion des demandes",
            review_digest: "Résumé hebdomadaire",
            send_review_requests: "Envoyer des demandes d'avis en masse"
        },
        texts: {
            add_customer_and_ask: "Ajoutez un nouveau client en utilisant les coordonnées que je vous fournirai, puis programmez une demande d'avis pour lui par e-mail avec 2 rappels.",
            customers_to_ask: "Affichez la liste de 50 clients maximum n'ayant jamais été sollicités pour un avis, triés par date d'inscription (du plus récent au plus ancien). Ignorez les clients désinscrits. Indiquez le nom, l'adresse e-mail et la date d'inscription.",
            location_leaderboard: "Créez un classement sur 90 jours par lieu, incluant le nombre d'avis, la note moyenne, le pourcentage d'avis 5 étoiles et l'évolution par rapport aux 90 jours précédents. Triez par note et signalez toute baisse supérieure à 0,2 étoile.",
            outreach_health: "Pour les courriels envoyés au cours des 14 derniers jours, veuillez indiquer le nombre total de courriels envoyés, le taux de distribution, le taux d'ouverture, le taux de clics et le taux d'échec. Signalez toute anomalie.",
            review_digest: "Résumez tous les avis des 7 derniers jours. Incluez le nombre d'avis, la note moyenne, la répartition par source et par lieu, les 3 principaux thèmes et les 3 principaux points soulevés.",
            send_review_requests: "Pour les clients inscrits au cours des 30 derniers jours et n'ayant pas encore reçu de demande d'avis, veuillez programmer une demande par courriel avec deux rappels. Veuillez d'abord afficher la liste et attendre ma confirmation."
        }
    },
    messages: {
        activated: "Activé avec succès.",
        archived: "Archivé avec succès.",
        canceled: "Annulé avec succès.",
        cannot_copy: "Impossible de copier dans le presse-papiers",
        cname_active: "L'état du CNAME est actif.",
        cname_not_active: "L'état du CNAME n'est pas encore actif.",
        connected: "Connecté avec succès.",
        cookie_banner_text: "Nous utilisons des cookies pour améliorer votre expérience. Vous pouvez personnaliser vos préférences ou tout accepter.",
        cookie_category_analytics_desc: "Ces cookies servent à mesurer le trafic du site web et l'utilisation des produits. Ils nous aident à comprendre comment les visiteurs utilisent notre site.",
        cookie_category_essential_desc: "Toujours actifs. Ces cookies sont nécessaires au fonctionnement du site et ne peuvent pas être désactivés.",
        cookie_category_functional_desc: "Activez les fonctionnalités avancées comme le chat en direct. Ces cookies ne vous suivent pas à des fins publicitaires.",
        cookie_category_marketing_desc: "Utilisé pour la publicité et la mesure des campagnes. Il peut s'agir de pixels publicitaires et d'outils d'attribution.",
        copied: "Copié avec succès.",
        copied_to_all_ratings: "Copié vers toutes les notes. Enregistrez pour appliquer.",
        created: "Créé avec succès.",
        deactivated: "Désactivé avec succès.",
        deleted: "Supprimé avec succès.",
        disconnected: "Déconnexion réussie.",
        duplicated: "Dupliqué avec succès.",
        error: "Une erreur s'est produite. Veuillez réessayer.",
        google_connect_failed: "Impossible de se connecter à Google. Vous pouvez réessayer ou ignorer cette étape pour le moment.",
        inquiry_sent: "Merci pour votre demande. Nous vous recontacterons sous peu.",
        oauth_consent_intro: "{client} demande l'autorisation d'accéder à votre compte.",
        oauth_request_missing: "La demande d'autorisation OAuth est manquante ou a expiré.",
        operation_connection_sync_failed: "La synchronisation {integration_name} a échoué.",
        operation_connection_sync_progress: "Synchronisation {integration_name}…",
        operation_connection_sync_success: "{integration_name} synchronisation terminée.",
        operation_customer_import_failed: "L'importation des Client a échoué.",
        operation_customer_import_progress: "Importer des clients…",
        operation_customer_import_success: "Importation Client terminée.",
        operation_review_import_failed: "L'importation de la Avis a échoué.",
        operation_review_import_progress: "Importer les avis…",
        operation_review_import_success: "Importation des Avis terminée.",
        operation_review_scrape_failed: "L'importation de la dernière révision a échoué.",
        operation_review_scrape_progress: "Importation des avis récents…",
        operation_review_scrape_success: "Importation des avis récents terminée.",
        processed: "Traité avec succès.",
        published: "Publié avec succès.",
        purchased: "Acheté avec succès.",
        queued: "Planifié avec succès.",
        refreshed: "Rafraîchi avec succès.",
        removed: "Supprimé avec succès.",
        resubscribed: "Réabonnement réussi.",
        revoked: "Révocation réussie.",
        saved: "Enregistré avec succès.",
        scheduled: "Planifié avec succès.",
        sent: "Envoyé avec succès.",
        started: "Démarré avec succès.",
        stopped: "Arrêté avec succès.",
        sso_failed: "Impossible de s'authentifier via SSO.",
        sso_invalid_callback: "Rappel SSO invalide.",
        sso_not_configured: "L'authentification unique (SSO) n'est pas configurée.",
        sso_openid_config_failed: "Impossible de charger la configuration OpenID.",
        sso_token_exchange_failed: "Impossible de terminer l'échange de jetons SSO.",
        subscribed: "Abonnement réussi.",
        suspended: "Suspendu avec succès.",
        synced: "Synchronisation réussie.",
        unarchived: "Désarchivé avec succès.",
        unpublished: "Inédit avec succès.",
        unscheduled: "Annulé avec succès.",
        unsubscribed: "Désabonnement réussi.",
        unsuspended: "Suspension annulée avec succès.",
        updated: "Mise à jour réussie.",
        upgraded: "Mise à niveau réussie.",
        validated: "Validé avec succès.",
        verified: "Vérifié avec succès."
    },
    notices: {
        agency: "Vous dirigez une agence? Vous pouvez utiliser notre produit en marque blanche afin que vos clients ne voient que votre marque lorsqu'ils utilisent le service.",
        ai_tags: "Créez un tag IA pour que les avis correspondant à vos instructions soient étiquetés automatiquement.",
        connected_apps: "Les applications que vous connectez via MCP apparaîtront ici.",
        connector: "Importez vos clients depuis des milliers d'applications avec {brand}.",
        customer_messages: "Demandez un avis pour planifier des messages.",
        customer_reviews: "Demandez un avis à ce client.",
        customers: "Importez vos clients pour qu'ils commencent à demander des avis.",
        customers_import_yourself: "Importez vos clients pour qu'ils commencent à demander des avis. Vous pouvez aussi vous importer d'abord pour essayer l'expérience avant d'inviter qui que ce soit.",
        external_links: "Ajoutez des liens externes à votre portail client pour promouvoir vos services. Ces liens seront visibles par vos clients dans la barre latérale.",
        links: "Ajoutez des boutons à votre page pour laisser des avis sur des sites Web tiers.",
        locations: "Créez un emplacement afin de pouvoir attribuer des avis à plusieurs emplacements.",
        ltd: "Débloquez un accès à vie avec votre code d'accès. Chaque code vous donne droit à un nombre limité de demandes mensuelles et à toutes les fonctionnalités. Les codes sont cumulables. 3 codes ou plus débloquent le forfait agence. Saisissez vos codes d'accès ci-dessous.",
        mcp_example_prompts: "Une fois le serveur MCP connecté, collez ces éléments dans votre assistant comme point de départ.",
        messages: "Chaque demande et rappel apparaîtra ici lorsque des avis seront demandés à vos clients.",
        no_commissions: "Vous n'avez pas encore perçu de commissions.",
        no_payouts: "Les paiements sont envoyés manuellement une fois que votre solde approuvé atteint au moins 50,00 $ et que votre compte bancaire est connecté.",
        no_projects: "Aucun projet ne vous a encore été attribué. Contactez votre administrateur pour obtenir l’accès.",
        no_referrals: "Vous n'avez encore parrainé personne. Partagez votre lien de parrainage pour commencer.",
        qr_codes: "Créez des codes QR avec des couleurs, des emplacements et des étiquettes personnalisés. Téléchargez-les au format SVG ou PNG.",
        referrals_share_subject: "Mon gestionnaire de réputation IA",
        referrals_share_text: "Mon arme secrète pour obtenir des avis clients: More Good Reviews. Une gestion de la réputation par IA qui fonctionne vraiment. Inscrivez-vous via mon lien:",
        review_pages: "Votre projet peut comporter plusieurs pages d'avis pour que vos clients puissent laisser des avis. Ceci est utile pour les entreprises ayant plusieurs établissements.",
        reviews: "Nous attendons les avis de vos clients.",
        showcase: "Nous ne faisons que commencer.",
        signatures: "Créez une signature e-mail à copier-coller dans votre application de messagerie.",
        sources: "Créez une source pour pouvoir catégoriser vos avis.",
        tag_rules: "Créez une règle pour catégoriser automatiquement vos avis avec l'IA.",
        tags: "Créez une étiquette pour catégoriser vos avis et vos clients.",
        unauthorized: "Vous n'avez pas la permission d'accéder à cette page.",
        unsubscribed: "Vous êtes désormais désabonné des demandes d'avis.",
        webhooks: "Ajoutez des webhooks pour être informé des événements de la plateforme.",
        widgets: "Créez des widgets pour intégrer des avis sur votre site Web.",
        your_referral_link_text: "Partagez votre lien pour gagner une commission récurrente de {rate} % sur chaque paiement de vos clients. Les paiements sont effectués manuellement dès que votre solde approuvé atteint au moins 50 $."
    },
    notification_types: {
        descriptions: {
            imports: "Envoyé une fois les importations terminées",
            new_reviews: "Envoyé dès réception des avis",
            sent_replies: "Envoyé lorsque les avis reçoivent une réponse automatique",
            weekly_reports: "Un résumé des activités est envoyé chaque semaine."
        },
        names: {
            imports: "Importations",
            new_reviews: "Nouveaux Avis",
            sent_replies: "Réponses envoyées",
            weekly_reports: "Rapports hebdomadaires"
        }
    },
    roles: {
        admin: "Administrateur",
        manager: "Directeur",
        operator: "Opérateur",
        owner: "Propriétaire",
        super_admin: "Super-administrateur",
        viewer: "Lecteur"
    },
    tasks: {
        automate: "Turn on automatic review requests and reminders. Each customer is contacted once, and can unsubscribe anytime.",
        customers: "Import customers with names and email or phone — manually, via Stripe, HubSpot, app connectors, the API, or by BCC’ing your project email on invoices.",
        google: "Connect Google Business Profile to import reviews, keep them in sync, and reply from here.",
        review_page: "Customize the page that captures reviews and can send customers to third-party sites — text, layout, fields, links, and redirects.",
        strategy: "Choose when customers are asked for reviews. We’ve set a simple default you can change anytime.",
        templates: "Edit the request and reminder emails customers receive. Both include one-click ratings, plus your logo and branding."
    },
    titles: {
        accept_invite: "Accepter l'invitation",
        accepting_invite: "Accepter l'invitation",
        access_denied: "Accès refusé",
        account: "Compte",
        actions: "Actions",
        add_custom_field: "Ajouter un champ personnalisé",
        add_ons: "Modules complémentaires",
        address: "Adresse",
        agencies: "Agences",
        agency: "Agence",
        ai: "IA",
        ai_assistant: "Assistant IA",
        ai_highlights: "Points saillants de l'IA",
        ai_replies: "Réponses de l'IA",
        ai_review_suggestions: "Suggestions d'avis par IA",
        ai_tags: "Tags IA",
        ai_tools: "Outils IA",
        analytics: "Analytique",
        api: "API",
        api_key: "Clé API",
        appearance: "Apparence",
        application_connectors: "Connecteurs d'application",
        attributes: "Attributs",
        authorize: "Autoriser",
        auto_tagging: "Marquage automatique",
        automate: "Automatiser",
        automatic_review_collection: "Collecte automatique des Avis",
        billing: "Facturation",
        branding: "Image de marque",
        change_password: "Changer le mot de passe",
        clients: "Clients",
        cname: "CNAME",
        conditions: "Conditions",
        confirmation_message: "Message de confirmation",
        connected_apps: "Applications connectées",
        contact_us: "Contactez-nous",
        cookie_policy: "Politique relative aux cookies",
        cookie_preferences: "Préférences relatives aux cookies",
        copy: "Copie",
        create_your_account: "Créez votre compte",
        crms: "CRMs",
        css: "CSS",
        custom_field: "Champ personnalisé",
        custom_fields: "Champs personnalisés",
        custom_icons: "Icônes personnalisées",
        customer: "Client",
        customer_facing_pages: "Pages destinées aux clients",
        customers: "Clients",
        dashboard: "Tableau de bord",
        details: "Détails",
        dmarc: "DMARC",
        domain: "Domaine",
        dpa: "Accord de traitement des données",
        dsar: "Demande d'accès aux données personnelles",
        email_address: "Adresse email",
        email_messages: "Messages électroniques",
        email_settings: "Paramètres de messagerie",
        email_usage: "Utilisation du courrier électronique",
        emails: "Courriels",
        embed_code: "Code d'intégration",
        examples: "Exemples",
        export: "Exporter",
        external_link: "Lien externe",
        external_link_num: "Lien externe #{num}",
        external_links: "Liens externes",
        field: "Champ",
        fields: "Champs",
        filters: "Filtres",
        form_fields: "Champs de formulaire",
        got_access_code: "Vous avez un code d'accès ?",
        hipaa: "Déclaration HIPAA",
        how_it_works: "Comment ça marche",
        incentive: "Incitation",
        instructions: "Instructions",
        integration: "Intégration",
        integrations: "Intégrations",
        javascript: "JavaScript",
        latest_reviews: "Derniers Avis",
        lifetime_deal: "Offre à vie",
        limits: "Limites",
        link: "Lien",
        links: "Liens",
        location: "Emplacement",
        location_picker: "Sélecteur d'emplacement",
        locations: "Emplacements",
        log_in: "Se connecter",
        log_out: "Se déconnecter",
        make_default: "Définir par défaut",
        manage_limits: "Gérer les limites",
        manage_overrides: "Gérer les remplacements",
        manage_review: "Gérer les Avis",
        mcp_example_prompts: "Exemples de questions",
        mcp_server: "Serveur MCP",
        message: "Message",
        messages: "Messages",
        meta: "Méta",
        no_clients: "Aucun client",
        no_commissions: "Aucune commission",
        no_connected_apps: "Aucune application connectée",
        no_custom_fields: "Aucun champ personnalisé",
        no_customers: "Aucun client",
        no_links: "Aucun Liens",
        no_locations: "Aucun emplacement",
        no_members: "Aucun membre",
        no_messages: "Aucun message",
        no_payouts: "Aucun paiement",
        no_projects: "Aucun projet",
        no_qr_codes: "Pas de codes QR",
        no_referrals: "Pas de recommandations",
        no_review_pages: "Aucune Pages d’Avis",
        no_reviews: "Aucun Avis",
        no_tags: "Aucune Étiquettes",
        no_team_members: "Aucun membre de l'équipe",
        no_template: "Pas de modèle",
        no_widgets: "Pas de widgets",
        notifications: "Notifications",
        options: "Options",
        overview: "Aperçu",
        payment_method: "Mode de paiement",
        photo: "Photo",
        plans: "Plans",
        powered_by: "Alimenté par",
        pricing: "Tarification",
        privacy_policy: "politique de confidentialité",
        profile: "Profil",
        project: "Projet",
        project_limits: "Limites du projet",
        project_overrides: "Remplacements de projets",
        projects: "Projets",
        qr_code: "Code QR",
        qr_codes: "Codes QR",
        ratings: "Notes",
        redeem_access_code: "Utiliser le code d'accès",
        redirecting: "Redirection",
        redirects: "Redirections",
        referrals_commissions: "Commissions",
        referrals_payouts: "Paiements",
        referral_program: "Conditions générales du programme de parrainage",
        reminders: "Rappels",
        reply: "Répondre",
        request: "Demande",
        request_options: "Options de demande",
        requests: "Demandes",
        required: "Requis",
        reschedule_message: "Reprogrammer le message",
        reset_password: "Réinitialiser le mot de passe",
        retries: "Tentatives",
        review: "Avis",
        review_link: "Lien vers l'avis",
        review_page: "Page d'avis",
        review_pages: "Pages d'avis",
        review_spotlight: "Avis en vedette",
        review_suggestions: "Suggestions d'avis",
        review_wall: "Mur d'avis",
        reviewer: "Auteur de l'avis",
        reviews: "Avis",
        save_changes: "Enregistrer les modifications",
        schedule: "Calendrier",
        scrape_a_website: "Extraire d’un site web",
        search_engines: "Moteurs de recherche",
        sections: "Sections",
        select_csv_file: "Sélectionner le fichier CSV",
        select_project: "Sélectionner un projet",
        selecting_project: "Sélection du projet",
        sending_domain: "Domaine d'envoi",
        sending_limits: "Limites d'envoi",
        settings: "Paramètres",
        setup: "Installation",
        setup_basics: "Votre stratégie de Demande",
        setup_business: "Commençons",
        setup_google: "Votre profil Google Business",
        setup_trusted: "Plus de 5 000 entreprises nous font confiance.",
        showcase: "Showcase",
        sign_up: "S'inscrire",
        signature: "Signature",
        signatures: "Signatures",
        signing_in: "Connexion",
        single_sign_on: "Authentification unique",
        slug: "Slug",
        sms: "SMS",
        sms_messages: "Messages SMS",
        sms_usage: "Utilisation des SMS",
        smtp_configuration: "Configuration SMTP",
        source: "Source",
        sources: "Sources",
        space: "Espace de travail",
        spaces: "Espaces de travail",
        stats: "Statistiques",
        sub_processors: "Sous-processeurs",
        success_page: "Page de réussite",
        summary: "Résumé",
        tag: "Étiquette",
        tag_rule: "Règle de balise",
        tags: "Étiquettes",
        team_members: "Membres de l'équipe",
        template: "Modèle",
        templates: "Modèles",
        terms_of_service: "Conditions d'utilisation",
        two_factor_authentication: "Authentification à deux facteurs",
        unable_to_complete_request: "Impossible de terminer la requête",
        unique_review_link: "Lien d'avis unique",
        unsent_messages: "Messages non envoyés",
        unsubscribe: "Se désabonner",
        update_plan: "Plan de mise à jour",
        usage: "Usage",
        user: "Utilisateur",
        user_info: "Informations utilisateur",
        verify_email_address: "Vérifier l'adresse e-mail",
        verifying_email: "Vérification de l'e-mail",
        visibility: "Visibilité",
        webhook: "Webhook",
        webhooks: "Webhooks",
        website: "Site web",
        white_label_api: "API en marque blanche",
        white_label_client_portal: "Portail client en marque blanche",
        white_label_image_urls: "URL d'images en marque blanche",
        white_label_sending_domain: "Domaine d'envoi en marque blanche",
        white_label_widget_tag: "Balise de widget en marque blanche",
        widget: "Widget",
        widget_num: "Widget #{num}",
        widgets: "Widgets",
        your_plan: "Votre plan"
    },
    tones: {
        apologetic: "Apologétique",
        casual: "Occasionnel",
        empathetic: "Empathique",
        enthusiastic: "Enthousiaste",
        formal: "Officiel",
        friendly: "Amical",
        grateful: "Reconnaissant",
        humorous: "Humoristique",
        informative: "Informatif"
    },
    widgets: {
        labels: {
            alignment: "Alignement",
            animation: "Animation",
            autoplay: "Lecture automatique",
            autoplay_delay: "Délai de lecture automatique",
            avatar: "Avatar",
            background_color: "Couleur d'arrière-plan",
            border: "Bordure",
            border_color: "Couleur de la bordure",
            border_radius: "Rayon de bordure",
            border_width: "Largeur de la bordure",
            carousel: "Carrousel",
            colors: "Couleurs",
            company: "Entreprise",
            customer: "Client",
            customer_position: "Position du client",
            date: "Date",
            delay: "Retard",
            design: "Design",
            design_prompt_placeholder: "Exemple : Doux et minimaliste, avec des étoiles dorées et des coins arrondis.",
            drop_shadow: "Ombre portée",
            duration: "Durée",
            filters: "Filtres",
            font: "Police",
            font_emphasis: "Mise en évidence de la police",
            font_family: "Famille de polices",
            font_size: "Taille de la police",
            include_hidden: "Inclure les Avis cachés",
            layout: "Mise en page",
            limit: "Avis par page",
            location_ids: "Emplacements",
            marquee: "Marquee",
            max_slides: "Diapositives Max",
            max_width: "Largeur maximale",
            name_convention: "Nom",
            padding: "Marge intérieure",
            pagination: "Pagination",
            quotes: "Citations",
            rating: "Note",
            rating_round: "Arrondir",
            rating_round_hundredth: "Au centième près (4,94)",
            rating_round_tenth: "Au dixième près (4,9)",
            review: "Avis",
            review_chars: "Longueur de l'avis",
            review_count: "Nombre d'avis",
            review_id: "Avis",
            review_ids: "Avis",
            review_ids_for_faces: "Avis sur Faces",
            reviews: "Avis",
            schema: "Schéma",
            schema_name: "Nom de l'entreprise",
            schema_type: "Type d'entreprise",
            score: "Note la plus basse",
            show_on_mobile: "Afficher sur mobile",
            slider: "Curseur",
            sort: "Trier",
            source: "Source",
            source_ids: "Sources",
            source_position: "Position de la source",
            speed: "Vitesse",
            star_color: "Couleur des étoiles",
            star_display: "Affichage des étoiles",
            star_size: "Taille de l'étoile",
            star_spacing: "Star Spacing",
            star_style: "Star Style",
            star_style_classic: "Classic",
            star_style_sharp: "Sharp",
            tag_ids: "Étiquettes",
            take: "Nombre maximal d' Avis",
            text_color: "Couleur du texte",
            truncate: "Raccourcir l'avis",
            visible_slides: "Diapositives visibles",
            width: "Largeur"
        },
        types: {
            badge: "Badge",
            carousel: "Carrousel",
            carousel_dynamic: "Carrousel dynamique",
            corner: "Coin",
            corner_dynamic: "Coin dynamique",
            faces: "Visages",
            headline: "Titre",
            highlights: "Points forts",
            marquee: "Marquee",
            spotlight: "En vedette",
            wall: "Mur"
        }
    }
}
